import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import EditorConvertToHTML from "./editor";
import Select from "react-select";
import { API_BASE_URL } from "../utils/endpoints";

import { encode } from "base-64";
import {
  Grid,
  Segment,
  Radio,
  Accordion,
  Pagination,
  Divider,
  Menu,
  Label,
  Header,
  Modal,
  Form,
  Step,
  Button,
  Icon,
  Input,
  Message,
  List,
  Checkbox,
  Image,
  Transition,
} from "semantic-ui-react";
import DateTime from "react-datetime";

// // import "react-phone-input-2/dist/style.css";
import HomeLocation from "./homeLocations";
import WorkLocation from "./workLocations";
import VacationLocation from "./vacationLocations";
const commaNumber = require("comma-number");

var balance_type = [];
var ENGLISH =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789()+_*&^%$#@! {}[]|?><:"';

////////////////////////// from add bulk sms ////////////////////
var back = "";

var categoryGroupOptions = [];
var array_data = [];
var category_ids = [];
var template = [];
var count = 1;
var data = new FormData();

var value_variables_one;

var countryOptions = [];
var yesterday = DateTime.moment().subtract(1, "day");
var valid = function(current) {
  return current.isAfter(yesterday);
};

const StepOneModal = {
  height: "auto",

  marginLeft: "30%",
  marginTop: 50,
};

const StepOneModal2 = {
  height: "auto",

  marginLeft: "25%",
  marginTop: 50,
};
const StepOneModala = {
  height: "auto",

  marginLeft: "15%",
  marginTop: 50,
};

const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

const modStop = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modStopa = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modDetails = {
  marginTop: 60,
  marginLeft: "25%",
  height: "auto",
  width: 1000,
  textAlign: "left",
};

const modDetailsa = {
  marginTop: 60,
  marginLeft: "15%",
  height: "auto",
  width: 1000,
  textAlign: "left",
};

class Profiled extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      disableButtton: false,
      selectedDays: [],
      countryOptions: [],
      view: [],
      modalIsOpen: false,
      modalOpenConfirm: false,
      show: false,

      data: [],
      Details: [],
      bulktotalpage: 1,
      disabled: false,
      bulkactivePage: 1,

      searchbulktotalpage: 1,
      searchbulkactivePage: 1,

      totalpage: 1,
      activePage: 1,
      date_format: [],
      modalIsOpenStop: false,
      id_stop: "",
      isLoading: true,
      isArabic: false,
      isOperator: true,
      bulk_balance: "",
      viewData: "",
      searchWord: "",
      exportFlag: false,
      modalOpenStopJop: false,

      fromDate: "",
      toDate: "",
      modalOpenFilterDetails: false,
      filterTotalpage: 1,
      Age: [],
      Gender: [],
      PackageType: [],
      Spending: [],
      Devices: [],
      Manufacturer: [],
      Cities: [],
      Districts: [],
      Areas: [],
      viewBoxSubmit: false,
      GOVERNORATE_WEEKDAY: [],
      GOVERNORATE_WEEKEND: [],
      GOVERNORATE_EVENING: [],
      DISTRICT_WEEKDAY: [],
      DISTRICT_WEEKEND: [],
      DISTRICT_EVENING: [],
      AREA_WEEKDAY: [],
      AREA_WEEKEND: [],
      AREA_EVENING: [],
      WorkHeader: "",
      flag: "",
      logic: "OR",
      numberOfMessages: "",
      numberOfMessagesContent: 0,
      senderidoption: [],
      options_sender: [],
      senderid: [],
      senderidselect: "",
      modalOpenBulkEdit: false,
      modalOpenViewDetails: false,
      Details: [],
      msg_id: "",
      displayViewBox: false,
      ViewBoxDetails: false,

      ////////////////////// form add bulk ////////////////////
      uploadfile: [],

      time: [
        { label: i18n.t("Send_Now.label"), value: 1 },
        { label: i18n.t("Schedule_time.label"), value: 2 },
      ],
      timeselect: [{ label: i18n.t("Send_Now.label"), value: 1 }],
      timeofsend: "",
      dateofsend: "",
      content: "",
      modalIsOpen: false,
      modalIsOpenContact: false,
      modalOpenSellectContact: false,
      show: false,

      confirm: "",
      resultall: "",
      resultallinvalid: "",
      persons: [],

      date: new Date(),
      send_now: true,
      content: "",
      title: "",
      service_type: "",
      params: {},
      sender_id: "",

      isArabic: false,
      balance_reserved: {},
      modalIsOpenScheule: false,
      file: null,
      recurring: new Date(),

      targetNum: 0,
      modalOpenBulkSMSStepHomeLocation: false,
      modalOpenBulkSMSStepWorkLocation: false,
      modalOpenBulkSMSStepVactionLocation: false,

      modalOpenBulkSMSStepOneNew: false,

      modalOpenDuplicate: false,
      DuplicatedObject: {},
      confirm_id: "",
      detailstotalpage: "0",

      searchdetailstotalpage: 1,
      searchdetailActivePage: 1,
    };

    /////////////////////////// from add bulk ///////////////

    this.openModalSchedule = this.openModalSchedule.bind(this);
    this.afterOpenModalSchedule = this.afterOpenModalSchedule.bind(this);
    this.closeModalSchedule = this.closeModalSchedule.bind(this);

    this.handleInputChange2 = this.handleInputChange2.bind(this);
  }

  handleOpenViewDetails = () => this.setState({ modalOpenViewDetails: true });
  handleCloseViewDetails = () => this.setState({ modalOpenViewDetails: false });

  handleOpenBulkSMSStepOne = () =>
    this.setState({ modalOpenBulkSMSStepOne: true });
  handleCloseBulkSMSStepOne = () =>
    this.setState({ modalOpenBulkSMSStepOne: false });

  handleOpenBulkSMSStepOneNew = () => {
    if (this.state.title === "") {
      //document.querySelector('.title_data').style='border-color:red';
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_title_field.label"),
        animation: "bounce",
        time: 5000,
      });
    }
    if ((this.state.senderidselect = "")) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        time: 5000,
      });
    }

    if ((this.state.numberOfMessages = "")) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000,
      });
    }

    if (this.state.numberOfMessages <= 0) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: "Nuber Of Tarfet Customers Should be More Than 0 ",
        animation: "bounce",
        time: 5000,
      });
    }

    this.setState({ modalOpenBulkSMSStepOneNew: true });
  };
  handleCloseBulkSMSStepOneNew = () =>
    this.setState({ modalOpenBulkSMSStepOneNew: false });

  handleOpenBulkSMSSteptTow = () => {
    this.setState({ modalOpenBulkSMSStepTow: true });
  };
  handleCloseBulkSMSStepTow = () =>
    this.setState({ modalOpenBulkSMSStepTow: false });

  handleOpenBulkSMSStepHomeLocation = () =>
    this.setState({ modalOpenBulkSMSStepHomeLocation: true });
  handleCloseBulkSMSStepHomeLocation = () =>
    this.setState({ modalOpenBulkSMSStepHomeLocation: false });

  handleOpenBulkSMSStepWorkLocation = () => {
    this.setState({ modalOpenBulkSMSStepWorkLocation: true });
  };
  handleCloseBulkSMSStepWorkLocation = () =>
    this.setState({ modalOpenBulkSMSStepWorkLocation: false });

  handleOpenBulkSMSStepVacationLocation = () =>
    this.setState({ modalOpenBulkSMSStepVactionLocation: true });
  handleCloseBulkSMSStepVacationLocation = () =>
    this.setState({ modalOpenBulkSMSStepVactionLocation: false });

  handleOpenSellectContact = () =>
    this.setState({ modalOpenSellectContact: true });
  handleCloseSellectContact = () =>
    this.setState({ modalOpenSellectContact: false });

  handleOpenConfirm = () => this.setState({ modalOpenConfirm: true });
  handleCloseConfirm = () => this.setState({ modalOpenConfirm: false });

  handleOpenStopJop = () => this.setState({ modalOpenStopJop: true });
  handleCloseStopJop = () => this.setState({ modalOpenStopJop: false });

  handleOpenViewDetails = () => this.setState({ modalOpenViewDetails: true });
  handleCloseViewDetails = () => this.setState({ modalOpenViewDetails: false });

  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });

  handleOpenBulkEdit = () => this.setState({ modalOpenBulkEdit: true });
  handleCloseBulkEdit = () => this.setState({ modalOpenBulkEdit: false });

  handleOpenDuplicate = () => this.setState({ modalOpenDuplicate: true });
  handleCloseDuplicate = () => this.setState({ modalOpenDuplicate: false });

  onChangedatetimerecurring = (date) => {
    date = new Date(date);
    this.setState({ recurring: date });
  };
  viewDate() {
    var array = this.state.selectedDays;
    this.setState({ view: array });
    document.querySelector(".viewTable").style = "display:block";
  }

  addItem() {
    var ul = document.getElementById("dynamic-list");
    // var candidate = document.getElementById("candidate");
    var li = document.createElement("li");
    li.setAttribute("id", this.state.recurring);
    li.appendChild(document.createTextNode(this.state.recurring));
    ul.appendChild(li);
  }

  removeItem(index) {
    var day = this.state.recurring;
    var month = day.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var hour = day.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    var date = day.getDate();
    if (date < 10) {
      date = "0" + date;
    }
    var minutes = day.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    var dformat =
      [day.getFullYear(), month, date].join("-") +
      "T" +
      [hour, minutes, day.getSeconds() + "0"].join(":") +
      "Z";

    const selectedIndex = this.state.selectedDays.indexOf(dformat);
    this.state.selectedDays.splice(index, 1);
    console.log(index);
    console.log(this.state.selectedDays);
    this.setState({ view: this.state.selectedDays });
  }

  handleDayClick() {
    var day = this.state.recurring;
    var month = day.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var hour = day.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    var date = day.getDate();
    if (date < 10) {
      date = "0" + date;
    }
    var minutes = day.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    var dformat =
      [day.getFullYear(), month, date].join("-") +
      "T" +
      [hour, minutes, day.getSeconds() + "0"].join(":") +
      "Z";

    if (this.state.selectedDays.includes(dformat)) {
    } else {
      this.state.selectedDays.push(dformat);
      // var ul = document.getElementById("dynamic-list");
      // // var candidate = document.getElementById("candidate");

      // var li = document.createElement("li");

      //  li.setAttribute('id',dformat);

      //  li.appendChild(document.createTextNode(dformat));
      //  ul.appendChild(li);
    }

    console.log(this.state.selectedDays);
    var array = this.state.selectedDays;
    this.setState({ view: array });
    document.querySelector(".viewTable").style = "display:block";
  }

  onChangeFromDate = (event) => {
    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();
    console.log(datevalue);
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    var timearray = timevalue.split(" ");
    var time = timearray[0];

    var timees = timevalue.split(":");
    var time_1 = timees[0];

    if (timearray[1] == "PM") {
      time_1 = Number(time_1) + 12;
    } else if (timearray[1] == "AM") {
      if (time_1 < 10) {
        time_1 = 0 + time_1;
      }
    }

    //  const fromDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2];
    const fromDate =
      day +
      "-" +
      month +
      "-" +
      year +
      " " +
      "00" +
      ":" +
      "00" +
      ":" +
      "59" +
      " " +
      "AM";

    this.setState({ fromDate: fromDate });
  };

  onChangeToDate = (event) => {
    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();

    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    console.log(timevalue, "time");
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    console.log(timearray[1]);

    var timees = timevalue.split(":");
    var time_1 = timees[0];

    if (timearray[1] == "PM") {
      time_1 = Number(time_1) + 12;
    } else if (timearray[1] == "AM") {
      if (time_1 < 10) {
        time_1 = 0 + time_1;
      }
    }

    // const toDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2];
    const toDate =
      day +
      "-" +
      month +
      "-" +
      year +
      " " +
      "23" +
      ":" +
      "59" +
      ":" +
      "59" +
      " " +
      "AM";

    console.log(toDate, "        toDate");
    this.setState({ toDate: toDate });
  };

  filterData() {
    this.setState({ modalOpenFilterDetails: false });
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: 0,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      service_type: "profiled_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);

      console.log(total);
      this.setState({ bulktotalpage: total });

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        this.setState({ data: data });
        this.setState({ isLoading: false });
        document.querySelector(".searchbulkpagination").style = "display:none";
        document.querySelector(".bulkpagination").style = "display:none";
        document.querySelector(".filterpagination").style = "display:block";
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  }

  handlePaginationFilterChange = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: page_num,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      service_type: "profiled_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);
      this.setState({ filterTotalpage: total });
      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        this.setState({ data: data });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  componentWillMount() {
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      this.setState({ isOperator: false });
    }

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.sender_ids != undefined) {
        const senderidoption = res.data.result.sender_ids;
        var length = res.data.result.sender_ids.length;
        var i;
        //  const newArr = this.state.options_sender;
        var newArr = [];
        for (i = 0; i < length; i++) {
          var value_option = senderidoption[i].sender_id;

          newArr.push({
            label: value_option,
            value: senderidoption[i].id,
          });
        }
        this.setState({ options_sender: res.data.result.sender_ids });
        this.setState({
          countryOptions: newArr,
        });

        countryOptions = newArr;
      }
    });

    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: page_num,
      service_type: "profiled_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;
      document.querySelector(".searchbulkpagination").style = "display:none";
      document.querySelector(".bulkpagination").style = "display:block";
      document.querySelector(".filterpagination").style = "display:none";
      var total = Math.ceil(res.data.result.count / 20);

      console.log(total);
      this.setState({ bulktotalpage: total });
      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        if (res.data.result.count === 0) {
          this.setState({ exportFlag: false });
        } else {
          this.setState({ exportFlag: true });
        }
        const data = res.data.result.jobs;
        this.setState({ data: data });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });

    var token = reactLocalStorage.get("accessToken");
    var user_id = this.state.user_id_login;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      } else {
        const data = res.data.result.balances;
        var array = [];
        if (data != undefined) {
          Object.keys(data).map(function(key) {
            array.push({
              label: key.replace(/_/g, " "),
              value: key,
            });
            balance_type = array;
          });
        }
      }
      this.setState({ code: "" });
    });
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      } else {
        const data = res.data.result.balances;
        var i;
        if (data) {
          var used;
          var reserved;
          var balance;
          var newbalance;
          var promo;
          var date = new Date();
          var day = date.getDate();
          if (day <= 9) {
            day = "0" + day;
          }
          var month = date.getMonth() + 1;
          if (month <= 9) {
            month = "0" + month;
          }
          var year = date.getFullYear();
          date = year + "-" + month + "-" + day;

          if (data.bulk_sms) {
            used = data.bulk_sms.used;
            reserved = data.bulk_sms.reserved;
            balance = data.bulk_sms.balance;
            promo = data.bulk_sms_promotion;
            if (promo) {
              this.setState({ isPromotion: true });
            }
            if (used != undefined && reserved != undefined) {
              newbalance = balance - used - reserved;
            } else if (used === undefined && reserved === undefined) {
              newbalance = data.bulk_sms.balance;
            } else if (reserved != undefined) {
              newbalance = data.bulk_sms.balance - data.bulk_sms.reserved;
            } else if (used != undefined) {
              newbalance = data.bulk_sms.balance - data.bulk_sms.used;
            }
            if (newbalance < 0) {
              //document.querySelector(".icon1 ").style = "display:none;";
            }
            this.setState({ bulk_balance: newbalance });

            this.setState({ bulk_expiry: data.bulk_sms.expiry });
          }
          if (data.profiled_sms) {
            var expiry = data.profiled_sms.expiry;
            if (expiry < date) {
              this.setState({ isOperator: false });
            }
            used = data.profiled_sms.used;
            reserved = data.profiled_sms.reserved;
            balance = data.profiled_sms.balance;

            /* promo=data.profiled.data.profiled+'_'+promotion;
            if(promo){
              this.setState({isPromotion:true})
            } */
            if (used != undefined && reserved != undefined) {
              newbalance = balance - used - reserved;
            } else if (used === undefined && reserved === undefined) {
              newbalance = data.profiled_sms.balance;
            } else if (reserved != undefined) {
              newbalance =
                data.profiled_sms.balance - data.profiled_sms.reserved;
            } else if (used != undefined) {
              newbalance = data.profiled_sms.balance - data.profiled_sms.used;
            }
            this.setState({ profiled_balance: newbalance });
            this.setState({ profiled_expiry: data.profiled_sms.expiry });
          }
          if (data.lba) {
            used = data.lba.used;
            reserved = data.lba.reserved;
            balance = data.lba.balance;
            newbalance = balance - used - reserved;
            //  promo=data.lba.data.lba+'_'+promotion;
            // if(promo){
            //   this.setState({isPromotion:true})
            // }
            if (used === undefined && reserved === undefined) {
              newbalance = data.lba.balance;
            }
            if (reserved != undefined) {
              newbalance = data.lba.balance - data.lba.reserved;
            }
            if (used != undefined) {
              newbalance = data.lba.balance - data.lba.used;
            }

            this.setState({ lba_balance: newbalance });
            this.setState({ lba_expiry: data.lba.expiry });
          }
          if (data.survey) {
            used = data.survey.used;
            reserved = data.survey.reserved;
            balance = data.survey.balance;
            newbalance = balance - used - reserved;
            /* promo=data.survey.data.survey+'_'+promotion;
                      if(promo){
                        this.setState({isPromotion:true})
                      }*/
            if (used === undefined && reserved === undefined) {
              newbalance = data.survey.balance;
            }
            if (reserved != undefined) {
              newbalance = data.survey.balance - data.survey.reserved;
            }
            if (used != undefined) {
              newbalance = data.survey.balance - data.survey.used;
            }
            this.setState({ survey_balance: newbalance });
            this.setState({ survey_expiry: data.survey.expiry });
          }
          if (data.international) {
            used = data.international.used;
            reserved = data.international.reserved;
            balance = data.international.balance;
            newbalance = balance - used - reserved;
            /*  promo=data.international.data.international+'_'+promotion;
                      if(promo){
                        this.setState({isPromotion:true})
                      }*/
            if (used === undefined && reserved === undefined) {
              newbalance = data.international.balance;
            }
            if (reserved != undefined) {
              newbalance =
                data.international.balance - data.international.reserved;
            }
            if (used != undefined) {
              newbalance = data.international.balance - data.international.used;
            }

            this.setState({ inter_balance: newbalance });
            this.setState({ inter_expiry: data.international.expiry });
          }
        } else {
          this.setState({ isOperator: false });
          this.setState({ bulk_balance: 0 });
        }
      }
    });
  }

  stopJob = (event) => {
    this.setState({ id_stop: event.target.id });
    this.setState({ modalOpenStopJop: true });
  };

  confirmStop = () => {
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/stopJob/" +
        this.state.id_stop;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/stopJob/" +
        this.state.id_stop;
    }

    var data = {};
    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: res.data.result.message,
        animation: "bounce",
        time: 5000,
      });
      this.setState({ modalIsOpenStop: false });
      var token = reactLocalStorage.get("accessToken");
      var page_num = this.state.activePage - 1;
      var data = {
        searchQuery: "",
        page: page_num,
        service_type: "profiled_sms",
      };
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      } else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      }
      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        if (res.data.status === "success") {
          const data = res.data.result.jobs;
          if (data != undefined) {
            this.setState({ data });
            window.location = "Profiled";
          }
        }
      });
    });
  };

  handlePaginationChangeSearchBasic = (e, { activePage }) => {
    this.setState({ activePage });

    //document.querySelector(".view_basic").style = "display:none";
    //document.querySelector(".view_search_basic").style = "display:block";
    var token = reactLocalStorage.get("accessToken");
    var page_num = activePage - 1;
    var data = {
      searchQuery: this.state.searchWord,
      page: page_num,
      service_type: "profiled_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;
      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ searchbulktotalpage: total });

      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }

      if (res.data.result.jobs != undefined) {
        this.setState({ data: res.data.result.jobs });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });

    var token = reactLocalStorage.get("accessToken");
    var data1 = {
      searchQuery: "",
      page: activePage - 1,
      service_type: "profiled_sms",
    };
    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data1, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ totalpage: total });
      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }

      if (res.data.result.jobs != undefined) {
        const data = res.data.result.jobs;
        this.setState({ data });
        this.setState({ isLoading: false });
      }
      var i, j;

      var array = [];

      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  test(value) {
    var d = new Date(value),
      dformat =
        [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    return dformat;
  }

  searchchangemain = (event) => {
    this.setState({ searchWord: event.target.value });
    if (event.target.value.length >= 2) {
      document.querySelector(".bulkpagination").style = "display:none";
      document.querySelector(".searchbulkpagination").style = "display:block";
      var token = reactLocalStorage.get("accessToken");
      var page_num = 0;
      var data = {
        searchQuery: event.target.value,
        page: page_num,
        service_type: "profiled_sms",
      };

      var ip = API_BASE_URL;

      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      } else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        const data = res.data.result;
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ searchbulktotalpage: total });

        let result = res.data.result.result;

        if (res.data.result.ErrorDescription === "user is not authenticated") {
          window.location = "/app";
        }

        if (res.data.result.jobs != undefined) {
          this.setState({ data: res.data.result.jobs });
          this.setState({ isLoading: false });
        }
        var i, j;

        var array = [];

        for (i = 0; i < data.length; i++) {
          var d = new Date(data[i].schedule_date),
            dformat =
              [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
              " " +
              [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
          array.push({ date: dformat });
        }
        this.setState({ date_format: array });
      });
    }
    if (event.target.value === "") {
      document.querySelector(".bulkpagination").style = "display:block";
      document.querySelector(".searchbulkpagination").style = "display:none";
      this.componentWillMount();
    }
  };

  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".yellow_color").style =
        "float:right;white-space: pre;";
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        document.querySelector(".search_web ").style =
          "margin-right: 57%; margin-top: 1%;";
      } else {
      }

      document.querySelector(".table").style = "width: 95%;margin-right: 2.5%;";

      document.querySelector(".ui.pagination.menu").style =
        "float: left !important; margin-left: 7% !important;";
      document.querySelector(".fixed_bulk").style =
        "margin-right: 0% !important;";
    }
  }

  exportData = (e) => {
    setInterval(this.exportDataTimer(), 5000);
  };

  exportDataTimer() {
    // document.querySelector(".viewBox").style = "display:block";
    var x = this;
    x.setState({
      displayViewBox: true,
    });
    var user_id = reactLocalStorage.get("user_id_login");
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_jobs";
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      var query = { file_id: user_id, service_type: "profiled_sms" };
    } else {
      var query = {
        file_id: user_id,
        user_id: user_id,
        service_type: "profiled_sms",
      };
    }
    query = encodeURI(JSON.stringify(query));
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName +
        "?query=" +
        query;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/Export/" +
        collectionName +
        "?query=" +
        query;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };

    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            // document.querySelector(".viewBox").style = "display:block";
            x.exportDataTimerInterval();
            x.setState({
              displayViewBox: true,
            });
            x.setState({ viewData: response.data.status });
          } else if (response.data.status === "ready to download") {
            // document.querySelector(".viewBox").style = "display:none";
            x.setState({ viewData: response.data.status });
            var collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
          }
          x.setState({
            displayViewBox: false,
          });
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  exportDataTimerInterval() {
    var x = this;
    var user_id = reactLocalStorage.get("user_id_login");
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_jobs";
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      var query = { file_id: user_id, service_type: "profiled_sms" };
    } else {
      var query = {
        file_id: user_id,
        user_id: user_id,
        service_type: "profiled_sms",
      };
    }
    query = encodeURI(JSON.stringify(query));
    var callexport = setInterval(function() {
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      }
      var headers = {
        "Content-Type": "application/json",
        token: token,
      };

      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              // document.querySelector(".viewBox").style = "display:block";
              x.setState({ viewData: response.data.status });
            } else if (response.data.status === "ready to download") {
              clearInterval(callexport);
              // document.querySelector(".viewBox").style = "display:none";
              x.setState({ viewData: response.data.status });
              var collectionName = response.data.file_name;
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 5000);
  }

  //////////////////////// from add bulk sms /////////////////////////
  goToAddProfiledSMS() {
    this.setState({ modalOpenBulkSMSStepOne: true });
    this.setState({
      title: "",
      senderidselect: "",
      typeofMSg: "",
      numberOfMessages: "",
    });
    var lang = i18n.language;

    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".yellow_color").style =
        "float:right;margin-right: 15%;white-space: pre;";
    }

    // to get templates
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = -1;
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/gettemplate?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result != undefined) {
        var i;

        var i;
        const newArr = [];
        for (i = 0; i < res.data.result.templates.length; i++) {
          var value_option = res.data.result.templates[i].template_name;

          newArr.push({
            label: value_option,
            value: res.data.result.templates[i].template_value,
          });
        }

        template = newArr;
      }
    });
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  onChangedatetime = (date) => {
    date = new Date(date);
    this.setState({ date });
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    this.subtitle.style.color = "#f00";
  }

  openModalSchedule() {
    this.setState({ modalIsOpenScheule: true });
  }

  afterOpenModalSchedule() {
    this.subtitle.style.color = "#f00";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
    this.setState({
      title: "",
      typeofMSg: "",
      content: "",
      send_now: true,
      senderidselect: "",
      groups_id: [],
      items: [],
      items2: [],
    });
    data.delete("file");
    data.delete("object");
    window.location = "Profiled";
  }

  afterOpenModalContact() {}

  closeModalSchedule() {
    this.setState({ modalIsOpenScheule: false });
    window.location = "Profiled";
  }

  handleChangeTitle = (event) => {
    //  document.querySelector('.title_data').style='border-color:#ced4da';
    this.setState({ title: event.target.value }, function() {});
  };

  isProbablyEnglish(str) {
    var index;

    for (index = str.length - 1; index >= 0; index--) {
      if (ENGLISH.indexOf(str.substring(index, index + 1)) < 0) {
        return false;
      }
    }
    return true;
  }

  handleChangeContent = (event) => {
    document.querySelector(".textarea_content").style = "border-color:#ced4da";
    this.setState({ content: event.target.value });

    var flag = this.isProbablyEnglish(this.state.content);
    console.log(this.isProbablyEnglish(this.state.content));
    if (flag === false) {
      if (event.target.value.length < 70) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 1 });
      }
      if (event.target.value.length == 70) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 1 });
      }
      if (event.target.value.length > 70 && event.target.value.length <= 134) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 2 });
      }
      if (event.target.value.length > 134 && event.target.value.length <= 201) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 3 });
      }
      if (event.target.value.length > 201 && event.target.value.length <= 268) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 4 });
      }
      if (event.target.value.length > 268 && event.target.value.length <= 335) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 5 });
      }
      if (event.target.value.length > 335 && event.target.value.length <= 402) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 6 });
      }
      if (event.target.value.length > 402 && event.target.value.length <= 469) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 7 });
      }
      if (event.target.value.length > 469 && event.target.value.length <= 536) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 8 });
      }
      if (event.target.value.length > 536 && event.target.value.length <= 603) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 9 });
      }
      if (event.target.value.length > 603 && event.target.value.length <= 670) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 10 });
      }

      if (event.target.value.length > 670) {
        console.log(event.target.value.length);
        this.setState({ numberOfMessagesContent: 11 });
        /* var num = Math.ceil(event.target.value.length / 67);
    
        this.setState({ numberOfMessagesContent: num });*/
      }
      if (event.target.value.length > 671) {
        console.log(event.target.value.length);
        var num = Math.ceil(event.target.value.length / 55);
        this.setState({ numberOfMessagesContent: num });
      }
    } else if (flag === true) {
      if (event.target.value.length < 160) {
        this.setState({ numberOfMessagesContent: 1 });
      }
      if (event.target.value.length == 160) {
        this.setState({ numberOfMessagesContent: 1 });
      }
      if (event.target.value.length > 160 && event.target.value.length <= 306) {
        this.setState({ numberOfMessagesContent: 2 });
      }
      if (event.target.value.length > 306 && event.target.value.length <= 459) {
        this.setState({ numberOfMessagesContent: 3 });
      }
      if (event.target.value.length > 459 && event.target.value.length <= 612) {
        this.setState({ numberOfMessagesContent: 4 });
      }
      if (event.target.value.length > 612 && event.target.value.length <= 765) {
        this.setState({ numberOfMessagesContent: 5 });
      }

      if (event.target.value.length > 765 && event.target.value.length <= 918) {
        // var num = Math.ceil(event.target.value.length / 153);

        this.setState({ numberOfMessagesContent: 6 });
      }
      if (
        event.target.value.length > 918 &&
        event.target.value.length <= 1071
      ) {
        this.setState({ numberOfMessagesContent: 7 });
      }
      if (
        event.target.value.length > 1071 &&
        event.target.value.length <= 1224
      ) {
        this.setState({ numberOfMessagesContent: 8 });
      }
      if (
        event.target.value.length > 1224 &&
        event.target.value.length <= 1377
      ) {
        this.setState({ numberOfMessagesContent: 9 });
      }
      if (
        event.target.value.length > 1377 &&
        event.target.value.length <= 1530
      ) {
        this.setState({ numberOfMessagesContent: 10 });
      }
      if (event.target.value.length > 1530) {
        this.setState({ numberOfMessagesContent: 11 });
      }
      if (event.target.value.length > 1531) {
        var num = Math.ceil(event.target.value.length / 12);
        // var num =num_calc +1 ;

        console.log("Number of message in English");
        console.log(num);
        this.setState({ numberOfMessagesContent: num });
      }
    }
    // if (event.target.value.includes("var_")) {
    //   count = event.target.value.split("var_").length - 1;
    // }

    // var ltrChars =
    //     "A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF" +
    //     "\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF",
    //   rtlChars = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC",
    //   rtlDirCheck = new RegExp("^[^" + ltrChars + "]*[" + rtlChars + "]");

    // if (rtlDirCheck.test(event.target.value) === true) {
    //   document.querySelector(".textarea__countar").style = "display:block";
    //   document.querySelector(".textarea__countar").style = "float:right";
    //   document.querySelector(".textarea__counten").style = "display:none";
    //   var textCount = event.target.value;

    //   if (textCount.length <= 70) {
    //     this.setState({ numberOfMessages: 1 });
    //   }
    //   if (textCount.length > 70 && textCount.length <= 134) {
    //     this.setState({ numberOfMessages: 2 });
    //   }
    //   if (textCount.length > 134 && textCount.length <= 201) {
    //     this.setState({ numberOfMessages: 3 });
    //   }

    //   if (textCount.length > 201) {
    //     var num = Math.ceil(textCount.length / 67);

    //     this.setState({ numberOfMessages: num });
    //   }
    // } else {
    //   document.querySelector(".textarea__countar").style = "display:none";
    //   document.querySelector(".textarea__counten").style = "display:block";
    //   document.querySelector(".textarea__counten").style = "float:right";
    //   var textCount = event.target.value;

    //   if (textCount.length <= 160) {
    //     this.setState({ numberOfMessages: 1 });
    //   }
    //   if (textCount.length > 160 && textCount.length <= 306) {
    //     this.setState({ numberOfMessages: 2 });
    //   }
    //   if (textCount.length > 306 && textCount.length <= 459) {
    //     this.setState({ numberOfMessages: 3 });
    //   }

    //   if (textCount.length > 459) {
    //     var num = Math.ceil(textCount.length / 153);

    //     this.setState({ numberOfMessages: num });
    //   }
    // }
  };

  handleChangeupload = (event) => {
    /* const newArr = this.state.file;

    if (newArr.length > 0) {
      this.setState({ uploadfile: [] });
      data.delete("file")
    }
    newArr.push(event.target.files[0]);
    this.setState({
      uploadfile: newArr
    });*/

    data.set("file", event.target.files[0]);
  };

  onChange = (values) => {
    this.setState({ typeofMSg: values.value });
    this.setState({ nameoftype: values.label });

    if (values.label === "File" || values.label === "ملف") {
      document.querySelector(".upload_div").style = "display:block";
    } else {
      document.querySelector(".upload_div").style = "display:none";
    }
  };

  onChangetime(values) {
    this.setState({
      timeselect: values,
    });
    if (values.label === "Schedule time" || values.label === "ضبط الوقت") {
      document.querySelector(".time_div").style = "display:block";
      this.setState({ send_now: false });
    } else {
      document.querySelector(".time_div").style = "display:none";
      this.setState({ send_now: true });
    }
  }

  onchangescheduledate = (event) => {
    this.setState({
      dateofsend: event.target.value,
    });
  };
  onchangeschedule = (event) => {
    this.setState({
      timeofsend: event.target.value,
    });
  };
  onChangesenderid = (event) => {
    this.setState({ senderidselect: event.label }, function() {});
  };
  openstep2 = () => {
    if (this.state.title === "") {
      //document.querySelector('.title_data').style='border-color:red';
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_title_field.label"),
        animation: "bounce",
        time: 5000,
      });
    } else if (this.state.senderidselect === "") {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        time: 5000,
      });
    } else if (this.state.numberOfMessages === "") {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000,
      });
    } else if (this.state.numberOfMessages <= 0) {
      toast({
        type: "error",
        title: i18n.t("error.label"),
        description: "Nuber Of Tarfet Customers Should be More Than 0 ",
        animation: "bounce",
        time: 5000,
      });
    } else if (
      this.state.title !== "" &&
      this.state.numberOfMessages !== 0 &&
      this.state.senderidselect !== ""

      //&& data.get("file")
    ) {
      this.setState({
        modalOpenBulkSMSStepOneNew: true,
        modalOpenBulkSMSStepOne: false,
      });
    }
  };

  submit = (event) => {
    event.preventDefault();

    if (this.state.send_now === false) {
      var token = reactLocalStorage.get("accessToken");
      var defaultDate = new Date();
      if (this.state.date >= defaultDate) {
        if (this.state.content === "") {
          document.querySelector(".textarea_content").style =
            "border-color:red";
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_content_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        } else if (this.state.content != "") {
          let currentComponent = this;
          currentComponent.setState({ viewBoxSubmit: true });

          var d = this.state.date;
          var month = d.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          var hour = d.getHours();
          if (hour < 10) {
            hour = "0" + hour;
          }
          var date = d.getDate();
          if (date < 10) {
            date = "0" + date;
          }
          var minutes = d.getMinutes();
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          var dformat =
            [d.getFullYear(), month, date].join("-") +
            "T" +
            [hour, minutes, d.getSeconds() + "0"].join(":") +
            "Z";

          var date_time = dformat;

          if (this.state.send_now === false) {
            var test = new Blob(
              [
                JSON.stringify({
                  numberOfMessages: this.state.numberOfMessages,
                  params: {
                    GENDER: this.state.Gender,
                    AGE: this.state.Age,
                    PACKAGE_TYPE: this.state.PackageType,
                    AVG_OG_REV_BRACKET: this.state.Spending,
                    HANDSET_OS: this.state.Devices,
                    HANDSET_TYPE: this.state.Manufacturer,
                    GOVERNORATE_WEEKEND: this.state.GOVERNORATE_WEEKEND,
                    GOVERNORATE_EVENING: this.state.GOVERNORATE_EVENING,
                    GOVERNORATE_WEEKDAY: this.state.GOVERNORATE_WEEKDAY,
                    DISTRICT_WEEKEND: this.state.DISTRICT_WEEKEND,
                    DISTRICT_EVENING: this.state.DISTRICT_EVENING,
                    DISTRICT_WEEKDAY: this.state.DISTRICT_WEEKDAY,
                    AREA_WEEKEND: this.state.AREA_WEEKEND,
                    AREA_EVENING: this.state.AREA_EVENING,
                    AREA_WEEKDAY: this.state.AREA_WEEKDAY,
                    logic: this.state.logic,
                  },
                  content: this.state.content,
                  service_type: "profiled_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  schedule_date: date_time,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],

              { type: "application/json" }
            );
            data.append("object", test);
          } else if (this.state.send_now === true) {
            var test = new Blob(
              [
                JSON.stringify({
                  numberOfMessages: this.state.numberOfMessages,
                  params: {
                    GENDER: this.state.Gender,
                    AGE: this.state.Age,
                    PACKAGE_TYPE: this.state.PackageType,
                    AVG_OG_REV_BRACKET: this.state.Spending,
                    HANDSET_OS: this.state.Devices,
                    HANDSET_TYPE: this.state.Manufacturer,
                    GOVERNORATE_WEEKEND: this.state.GOVERNORATE_WEEKEND,
                    GOVERNORATE_EVENING: this.state.GOVERNORATE_EVENING,
                    GOVERNORATE_WEEKDAY: this.state.GOVERNORATE_WEEKDAY,
                    DISTRICT_WEEKEND: this.state.DISTRICT_WEEKEND,
                    DISTRICT_EVENING: this.state.DISTRICT_EVENING,
                    DISTRICT_WEEKDAY: this.state.DISTRICT_WEEKDAY,
                    AREA_WEEKEND: this.state.AREA_WEEKEND,
                    AREA_EVENING: this.state.AREA_EVENING,
                    AREA_WEEKDAY: this.state.AREA_WEEKDAY,
                    logic: this.state.logic,
                  },
                  content: this.state.content,
                  service_type: "profiled_sms",
                  send_now: this.state.send_now,
                  sender_id: this.state.senderidselect,
                  schedule_date: date_time,
                  title: this.state.title,
                  recurring: this.state.selectedDays,
                }),
              ],

              { type: "application/json" }
            );
            data.append("object", test);
          }
          this.setState({ disableButtton: true });

          var ip = API_BASE_URL;
          var s2 = "localhost:3000";
          var apiBaseUrl;
          if (ip.includes(s2)) {
            apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
          } else {
            apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
          }

          axios
            .post(apiBaseUrl, data, {
              headers: { "Content-Type": "multipart/form-data", token: token },
            })
            .then((response) => {
              currentComponent.setState({ disableButtton: false });
              if (response.status === 200) {
                var result = response.data.result;

                if (
                  result != undefined &&
                  response.data.status == "send confirm!"
                ) {
                  currentComponent.setState({
                    resultall: parseFloat(
                      response.data.result.valid_numbers_count
                    ),
                  });
                  currentComponent.setState({
                    confirm_id: response.data.result.confirm_id,
                  });

                  currentComponent.setState({
                    resultallinvalid:
                      response.data.result.invalid_numbers_count,
                  });
                  currentComponent.setState({
                    callbackDataValid: response.data.result.valid_numbers,
                  });
                  currentComponent.setState({
                    totalmsg: response.data.result.total_messages,
                  });
                  currentComponent.setState({
                    balance_reserved:
                      response.data.result.balance_reserved.profiled_sms,
                  });
                  currentComponent.setState({
                    callbackDataInValid: response.data.result.invalid_numbers,
                  });

                  currentComponent.setState({ viewBoxSubmit: false });
                  currentComponent.setState({ modalOpenConfirm: true });

                  currentComponent.setState({ confirm: result.confirm_id });
                } else {
                  toast({
                    type: "warning",
                    title: i18n.t("warning.label"),
                    description: response.data.status,
                    animation: "bounce",
                    time: 5000,
                  });
                  // document.getElementById("btn_back_step3").disabled = false;
                }
                data.delete("file");
                data.delete("object");

                back = "true";
              } else if (response.status === 204) {
                console.log("Something wrong");
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("Something_wrong.label"),
                  animation: "bounce",
                  time: 5000,
                });
                // document.getElementById("btn_back_step3").disabled = false;
              }
            })
            .catch(function(error) {
              console.log(error);
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("Something_wrong.label"),
                animation: "bounce",
                time: 5000,
              });
              // document.getElementById("btn_back_step3").disabled = false;
            });
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_all_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_choose_avalid_time.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    } else {
      if (this.state.content === "") {
        document.querySelector(".textarea_content").style = "border-color:red";
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_content_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      } else if (this.state.content != "") {
        let currentComponent = this;
        var token = reactLocalStorage.get("accessToken");
        this.setState({ viewBoxSubmit: true });

        var d = this.state.date;
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var hour = d.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var date = d.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var minutes = d.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        var dformat =
          [d.getFullYear(), month, date].join("-") +
          "T" +
          [hour, minutes, d.getSeconds() + "0"].join(":") +
          "Z";

        if (this.state.send_now === false) {
          var test = new Blob(
            [
              JSON.stringify({
                numberOfMessages: this.state.numberOfMessages,
                params: {
                  GENDER: this.state.Gender,
                  AGE: this.state.Age,
                  PACKAGE_TYPE: this.state.PackageType,
                  AVG_OG_REV_BRACKET: this.state.Spending,
                  HANDSET_OS: this.state.Devices,
                  HANDSET_TYPE: this.state.Manufacturer,
                  GOVERNORATE_WEEKEND: this.state.GOVERNORATE_WEEKEND,
                  GOVERNORATE_EVENING: this.state.GOVERNORATE_EVENING,
                  GOVERNORATE_WEEKDAY: this.state.GOVERNORATE_WEEKDAY,
                  DISTRICT_WEEKEND: this.state.DISTRICT_WEEKEND,
                  DISTRICT_EVENING: this.state.DISTRICT_EVENING,
                  DISTRICT_WEEKDAY: this.state.DISTRICT_WEEKDAY,
                  AREA_WEEKEND: this.state.AREA_WEEKEND,
                  AREA_EVENING: this.state.AREA_EVENING,
                  AREA_WEEKDAY: this.state.AREA_WEEKDAY,
                  logic: this.state.logic,
                },
                content: this.state.content,
                service_type: "profiled_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                schedule_date: date_time,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],

            { type: "application/json" }
          );
          data.append("object", test);
        } else if (this.state.send_now === true) {
          var test = new Blob(
            [
              JSON.stringify({
                numberOfMessages: this.state.numberOfMessages,
                params: {
                  GENDER: this.state.Gender,
                  AGE: this.state.Age,
                  PACKAGE_TYPE: this.state.PackageType,
                  AVG_OG_REV_BRACKET: this.state.Spending,
                  HANDSET_OS: this.state.Devices,
                  HANDSET_TYPE: this.state.Manufacturer,
                  GOVERNORATE_WEEKEND: this.state.GOVERNORATE_WEEKEND,
                  GOVERNORATE_EVENING: this.state.GOVERNORATE_EVENING,
                  GOVERNORATE_WEEKDAY: this.state.GOVERNORATE_WEEKDAY,
                  DISTRICT_WEEKEND: this.state.DISTRICT_WEEKEND,
                  DISTRICT_EVENING: this.state.DISTRICT_EVENING,
                  DISTRICT_WEEKDAY: this.state.DISTRICT_WEEKDAY,
                  AREA_WEEKEND: this.state.AREA_WEEKEND,
                  AREA_EVENING: this.state.AREA_EVENING,
                  AREA_WEEKDAY: this.state.AREA_WEEKDAY,
                  logic: this.state.logic,
                },
                content: this.state.content,
                service_type: "profiled_sms",
                send_now: this.state.send_now,
                sender_id: this.state.senderidselect,
                schedule_date: date_time,
                title: this.state.title,
                recurring: this.state.selectedDays,
              }),
            ],

            { type: "application/json" }
          );
          data.append("object", test);
        }
        this.setState({ disableButtton: true });

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
        } else {
          apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
        }

        axios
          .post(apiBaseUrl, data, {
            headers: { "Content-Type": "multipart/form-data", token: token },
          })
          .then((response) => {
            currentComponent.setState({ disableButtton: false });
            if (response.status === 200) {
              var result = response.data.result;

              if (
                result != undefined &&
                response.data.status === "send confirm!"
              ) {
                currentComponent.setState({
                  resultall: response.data.result.valid_numbers_count,
                });
                currentComponent.setState({
                  confirm_id: response.data.result.confirm_id,
                });
                currentComponent.setState({
                  resultallinvalid: response.data.result.invalid_numbers_count,
                });
                currentComponent.setState({
                  callbackDataValid: response.data.result.valid_numbers,
                });
                currentComponent.setState({
                  totalmsg: response.data.result.total_messages,
                });
                currentComponent.setState({
                  balance_reserved:
                    response.data.result.balance_reserved.profiled_sms,
                });
                currentComponent.setState({
                  callbackDataInValid: response.data.result.invalid_numbers,
                });
                currentComponent.setState({ viewBoxSubmit: false });

                currentComponent.setState({ modalOpenConfirm: true });

                currentComponent.setState({ confirm: result.confirm_id });
              } else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.status,
                  animation: "bounce",
                  time: 5000,
                });
                // document.getElementById("btn_back_step3").disabled = false;
              }
              data.delete("file");
              data.delete("object");

              back = "true";
            } else if (response.status === 204) {
              console.log("Something wrong");
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("Something_wrong.label test"),
                animation: "bounce",
                time: 5000,
              });
              // document.getElementById("btn_back_step3").disabled = false;
            }
          });
        /* .catch(function(error) {
            console.log(error);
            toast({
              type: 'error',
              title: i18n.t('error.label'),
              description:i18n.t('Something_wrong.label test2'),
              animation: 'bounce',
              time: 5000,
  
          });
          //document.getElementById("btn_back_step3").disabled = false;
          }); */
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    }
  };

  closemodalcontact = () => {
    this.setState({ modalIsOpenContact: false });
  };

  confirm_msg = (event) => {
    event.preventDefault();
    document.getElementById("confirm_sms").disabled = true;
    let currentComponent = this;
    var token = reactLocalStorage.get("accessToken");
    var confirm = this.state.confirm;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/confirmSMS/" +
        confirm;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/confirmSMS/" + confirm;
    }

    var data = {};
    axios
      .post(apiBaseUrl, data, {
        headers: { "Content-Type": "application/json", token: token },
      })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.result != undefined) {
            if (response.data.status === "saved successfully!") {
              currentComponent.setState({ modalOpenConfirm: false });
              window.location = "Profiled";
              // currentComponent.setState({ modalIsOpenScheule : true });
            } else {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: response.data.status,
                animation: "bounce",
                time: 5000,
              });
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };

  onChangetemplate = (event) => {
    value_variables_one = this.state.content + " " + event.value;
    this.setState({ content: value_variables_one });
  };

  handleInputChange(evt) {
    this.setState({ input: evt.target.value });
  }

  handleInputChange2(evt) {
    this.setState({ input2: evt.target.value });
  }

  addVariables = () => {
    var content_data = this.state.content;
    var new_data = "";
    if (content_data.length > 0) {
      if (content_data.includes("var_")) {
        count = count + 1;

        new_data = content_data + " " + "{var_" + count + "}";
        this.setState({ content: new_data });
      } else {
        new_data = content_data + " " + "{var_" + count + "}";
        this.setState({ content: new_data });
      }
    }
  };

  goBackOne() {
    this.setState({
      modalOpenBulkSMSStepOne: true,
      modalOpenBulkSMSStepTow: false,
    });
  }
  goBackTow() {
    this.setState({
      modalOpenBulkSMSStepOneNew: true,
      modalOpenBulkSMSStepHomeLocation: false,
    });
  }

  goBackThree() {
    this.setState({
      modalOpenBulkSMSStepHomeLocation: true,
      modalOpenBulkSMSStepWorkLocation: false,
    });
  }

  goBackFour() {
    this.setState({
      modalOpenBulkSMSStepWorkLocation: true,
      modalOpenBulkSMSStepVactionLocation: false,
    });
  }

  goBackFive() {
    this.setState({ viewBoxSubmit: false });
    this.setState({
      modalOpenBulkSMSStepVactionLocation: true,
      modalOpenBulkSMSStepTow: false,
    });
  }

  toggleVisibility = () =>
    this.setState((prevState) => ({ visible: !prevState.visible }));

  showMobigram() {
    // document.getElementsByClassName(".mobigram").style='display:block'

    if (document.querySelector(".mobigram").style.display === "none") {
      document.querySelector(".mobigram").style = "display:block";
    } else {
      document.querySelector(".mobigram").style = "display:none";
    }
  }
  showRecurring() {
    if (document.querySelector(".recurring").style.display === "none") {
      document.querySelector(".recurring").style = "display:block";
    } else {
      document.querySelector(".recurring").style = "display:none";
    }
  }

  setTextAreaValue(data) {
    // if(reactLocalStorage.get('url')!= undefined){
    document.querySelector("contentArea").value += data;
  }
  //}

  handleSubmitEditor = (value) => {
    this.setState({
      loading: true,
    });
    const val = value;

    var data = {
      base64html: encode(value),
    };

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/general/mobigram";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/general/mobigram";
    }

    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            loading: false,
          });
          if (response.data.result != undefined) {
            if (response.data.status === "success") {
              var result = response.data.result.url;
              console.log(result);

              // let url = result.replace("isms", "solutions1");
              let url = result;
              console.log(url);
              //let url = result;
              //window.open(url, "_blank");
              // reactLocalStorage.set("url", url);
              //document.querySelector("contentArea").value=url
              document.getElementById("contentArea").value += url;
              this.setState({
                content: document.getElementById("contentArea").value,
              });
              //this.setTextAreaValue(url);
            } else {
              toast({
                type: "warning",
                title: i18n.t("warning.label"),
                description: response.data.status,
                animation: "bounce",
                time: 5000,
              });
            }
          }
        } else if (response.status === 204) {
          this.setState({
            loading: false,
          });
          console.log("Something wrong");

          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          this.setState({
            loading: false,
          });
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        this.setState({
          loading: false,
        });
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  };
  close() {
    this.setState({
      modalOpenBulkSMSStepTow: false,
      modalOpenBulkSMSStepOneNew: false,
      modalOpenBulkSMSStepOne: false,
    });
  }

  setLogic = (event) => {
    var id = event.target.id;

    if (document.getElementById(id).checked === true) {
      this.setState({ logic: "OR" });
      console.log(this.state.logic);
    } else if (document.getElementById(id).checked === false) {
      this.setState({ logic: "AND" });
      console.log(this.state.logic);
    }
  };
  addAge = (event) => {
    var id = event.target.id;
    var value = event.target.value;

    if (document.getElementById(id).checked === true) {
      this.state.Age.push(value);
    } else if (document.getElementById(id).checked === false) {
      this.state.Age = this.state.Age.filter((item) => item !== value);
    }
    console.log(this.state.Age);
  };

  addGender = (event) => {
    var id = event.target.id;
    var value = event.target.value;

    if (document.getElementById(id).checked === true) {
      this.state.Gender.push(value);
    } else if (document.getElementById(id).checked === false) {
      this.state.Gender = this.state.Gender.filter((item) => item !== value);
    }
    console.log(this.state.Gender);
  };

  addPacakegeType = (event) => {
    var id = event.target.id;
    var value = event.target.value;

    if (document.getElementById(id).checked === true) {
      this.state.PackageType.push(value);
    } else if (document.getElementById(id).checked === false) {
      console.log("false");
      this.state.PackageType = this.state.PackageType.filter(
        (item) => item !== value
      );
    }
    console.log(this.state.PackageType);
  };

  addSpending = (event) => {
    var id = event.target.id;
    var value = event.target.value;
    var Avarage = [
      "REVENUE<=0",
      "0<REVENUE<=1",
      "1<REVENUE<=2",
      "2<REVENUE<=3",
      "3<REVENUE<=4",
      "4<REVENUE<=5",
      "5<REVENUE<=6",
      "6<REVENUE<=7",
      "7<REVENUE<=8",
      "8<REVENUE<=9",
      "9<REVENUE<=10",
      "10<REVENUE<=15",
    ];

    var High = [
      "15<REVENUE<=20",
      "20<REVENUE<=25",
      "25<REVENUE<=30",
      "30<REVENUE<=35",
      "35<REVENUE<=40",
      "40<REVENUE<=45",
      "45<REVENUE<=50",
      "50<REVENUE<=55",
      "55<REVENUE<=60",
      "60<REVENUE<=65",
      "65<REVENUE<=70",
      "70<REVENUE<=75",
      "75<REVENUE<=80",
      "80<REVENUE<=85",
      "85<REVENUE<=90",
      "90<REVENUE<=95",
      "95<REVENUE< = 100",
      "100<REVENUE<=110",
      "110<REVENUE<=120",
      "120<REVENUE<=130",
      "130<REVENUE<=140",
      "140<REVENUE<=150",
      "150<REVENUE<=160",
      "160<REVENUE<=170",
      "170<REVENUE<=180",
      "180<REVENUE<=190",
      "190<REVENUE<=200",
      "REVENUE>200",
    ];

    if (document.getElementById(id).checked === true) {
      if (event.target.value === "HIGH") {
        var i;
        for (i = 0; i < High.length; i++) {
          this.state.Spending.push(High[i]);
        }
      } else {
        // this.state.Spending.push(value)
        for (var i = 0; i < Avarage.length; i++) {
          this.state.Spending.push(Avarage[i]);
        }
      }
    } else if (document.getElementById(id).checked === false) {
      if (event.target.value === "HIGH") {
        var i;
        for (i = 0; i < High.length; i++) {
          this.state.Spending = this.state.Spending.filter(
            (item) => item !== High[i]
          );
        }
      } else {
        // this.state.Spending.push(value)
        for (var i = 0; i < Avarage.length; i++) {
          this.state.Spending = this.state.Spending.filter(
            (item) => item !== Avarage[i]
          );
        }
      }
    }
    console.log(this.state.Spending);
  };

  addDevicePlatform = (event) => {
    var id = event.target.id;
    var value = event.target.value;

    if (document.getElementById(id).checked === true) {
      this.state.Devices.push(value);
    } else if (document.getElementById(id).checked === false) {
      this.state.Devices = this.state.Devices.filter((item) => item !== value);
    }
    console.log(this.state.Devices);
  };

  addManufacturer = (event) => {
    var id = event.target.id;
    var value = event.target.value;

    if (document.getElementById(id).checked === true) {
      this.state.Manufacturer.push(value);
    } else if (document.getElementById(id).checked === false) {
      this.state.Manufacturer = this.state.Manufacturer.filter(
        (item) => item !== value
      );
    }
    console.log(this.state.Manufacturer);
  };

  addworkLocationCategorys = (event) => {
    var id = event.target.id;
    var token = reactLocalStorage.get("accessToken");
    if (document.getElementById(id).checked === false) {
      document.querySelector(".workgover").style = "display:none";
    } else {
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/general/getProfiledLocationData?collection=governorate&id=";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "core/user/rest/general/getProfiledLocationData?collection=governorate&id=";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data.result.data !== undefined) {
          this.setState({ Cities: res.data.result.data });
          reactLocalStorage.set("flag", "work");

          document.querySelector(".workgover").style = "display:block";
        }
      });
    }
  };

  addHomeGover = (value, flag) => {
    // this.state.GOVERNORATE_WEEKDAY.push(value);
    if (flag === "flag") {
      this.state.GOVERNORATE_EVENING = this.state.GOVERNORATE_EVENING.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      if (this.state.GOVERNORATE_EVENING.includes(value) === false) {
        this.state.GOVERNORATE_EVENING.push(value);
      }
    }
  };

  addHomeDistrict = (value, flag) => {
    if (flag === "flag") {
      this.state.DISTRICT_EVENING = this.state.DISTRICT_EVENING.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      if (this.state.DISTRICT_EVENING.includes(value) === false) {
        this.state.DISTRICT_EVENING.push(value);
      }
    }
  };

  addHomeArea = (value, flag) => {
    if (flag === "flag") {
      this.state.AREA_EVENING = this.state.AREA_EVENING.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      this.state.AREA_EVENING.push(value);
    }
  };

  addWorkGover = (value, flag) => {
    // this.state.GOVERNORATE_WEEKDAY.push(value);
    if (flag === "flag") {
      this.state.GOVERNORATE_WEEKDAY = this.state.GOVERNORATE_WEEKDAY.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      if (this.state.GOVERNORATE_WEEKDAY.includes(value) === false) {
        this.state.GOVERNORATE_WEEKDAY.push(value);
      }
    }
  };

  addWorkDistrict = (value, flag) => {
    if (flag === "flag") {
      this.state.DISTRICT_WEEKDAY = this.state.DISTRICT_WEEKDAY.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      if (this.state.DISTRICT_WEEKDAY.includes(value) === false) {
        this.state.DISTRICT_WEEKDAY.push(value);
      }
    }
  };

  addWorkArea = (value, flag) => {
    if (flag === "flag") {
      this.state.AREA_WEEKDAY = this.state.AREA_WEEKDAY.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      this.state.AREA_WEEKDAY.push(value);
    }
  };

  addVacationGover = (value, flag) => {
    console.log(value);
    if (flag === "flag") {
      this.state.GOVERNORATE_WEEKEND = this.state.GOVERNORATE_WEEKEND.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      if (this.state.GOVERNORATE_WEEKEND.includes(value) === false) {
        this.state.GOVERNORATE_WEEKEND.push(value);
      }
    }
  };

  addVacationDistrict = (value, flag) => {
    if (flag === "flag") {
      this.state.DISTRICT_WEEKEND = this.state.DISTRICT_WEEKEND.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      if (this.state.DISTRICT_WEEKEND.includes(value) === false) {
        this.state.DISTRICT_WEEKEND.push(value);
      }
    }
  };

  addVacationArea = (value, flag) => {
    if (flag === "flag") {
      this.state.AREA_WEEKEND = this.state.AREA_WEEKEND.filter(
        (item) => item !== value
      );
    }
    if (flag === "value") {
      this.state.AREA_WEEKEND.push(value);
    }
  };

  addLogic = (value) => {
    this.setState({ logic: value });
    console.log(this.state.logic);
  };

  onChangesenderid = (event) => {
    this.setState({ senderidselect: event.label }, function() {});
  };

  openEdit = (event) => {
    var id = event.target.id;
    this.setState({
      msg_id: id,
      modalOpenBulkEdit: true,
    });
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: page_num,
      service_type: "profiled_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.count / 20);

      console.log(total);
      this.setState({ bulktotalpage: total });

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobs != undefined) {
        for (i = 0; i < res.data.result.jobs.length; i++) {
          if (res.data.result.jobs[i].id === id) {
            var d = new Date(res.data.result.jobs[i].schedule_date),
              dformat =
                [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
                " " +
                [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
            //array.push({ date: dformat });

            this.setState({
              content: res.data.result.jobs[i].content,
              send_now: res.data.result.jobs[i].send_now,
              date: dformat,
            });
          }
        }
      }
      var i, j;

      var array = [];
      for (i = 0; i < data.length; i++) {
        var d = new Date(data[i].schedule_date),
          dformat =
            [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
            " " +
            [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
        array.push({ date: dformat });
      }
      this.setState({ date_format: array });
    });
  };

  submitEdit() {
    if (this.state.send_now === false) {
      var token = reactLocalStorage.get("accessToken");
      var defaultDate = new Date();
      if (this.state.date >= defaultDate) {
        if (this.state.content != "") {
          var d = this.state.date;
          var month = d.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          var hour = d.getHours();
          if (hour < 10) {
            hour = "0" + hour;
          }
          var date = d.getDate();
          if (date < 10) {
            date = "0" + date;
          }
          var minutes = d.getMinutes();
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          var dformat =
            [d.getFullYear(), month, date].join("-") +
            "T" +
            [hour, minutes, d.getSeconds() + "0"].join(":") +
            "Z";
          var data = {
            content: this.state.content,

            send_now: this.state.send_now,

            schedule_date: dformat,
            job_id: this.state.msg_id,
          };

          var ip = API_BASE_URL;

          var s2 = "localhost:3000";
          var apiBaseUrl;
          if (ip.includes(s2)) {
            apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/updateJob`;
          } else {
            apiBaseUrl =
              API_BASE_URL + `/core/user/rest/jobs/updateJob`;
          }

          var headers = { "Content-Type": "application/json", token: token };
          axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
            if (res.status === 200) {
              if (res.data.status === "success") {
                window.location = "Profiled";
              }
            }
          });
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_all_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_choose_avalid_time.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    } else {
      if (this.state.content === "") {
        document.querySelector(".textarea_content").style = "border-color:red";
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_content_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      } else if (this.state.content != "") {
        var token = reactLocalStorage.get("accessToken");
        var d = new Date();
        console.log(d);
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var hour = d.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var date = d.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var minutes = d.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        var dformat =
          [d.getFullYear(), month, date].join("-") +
          "T" +
          [hour, minutes, d.getSeconds() + "0"].join(":") +
          "Z";

        var data = {
          content: this.state.content,

          send_now: this.state.send_now,
          job_id: this.state.msg_id,

          //schedule_date: dformat,
        };

        var ip = API_BASE_URL;

        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/updateJob`;
        } else {
          apiBaseUrl =
            API_BASE_URL + `/core/user/rest/jobs/updateJob`;
        }

        var headers = { "Content-Type": "application/json", token: token };
        axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
          if (res.status === 200) {
            if (res.data.status === "success") {
              window.location = "Profiled";
            }
          }
        });
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    }
  }

  pauseJob = (event) => {
    var token = reactLocalStorage.get("accessToken");
    var id = event.target.id;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/pauseResumeJob/${id}`;
    } else {
      apiBaseUrl =
        API_BASE_URL + `/core//user/rest/jobs/pauseResumeJob/${id}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          toast({
            type: "success",
            title: i18n.t("success.label"),
            description: "Job paused Successfully ",
            animation: "bounce",
            time: 5000,
          });
        }
      }
    });
  };

  resumeJob = (event) => {
    var token = reactLocalStorage.get("accessToken");
    var id = event.target.id;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/pauseResumeJob/${id}`;
    } else {
      apiBaseUrl =
        API_BASE_URL + `/core//user/rest/jobs/pauseResumeJob/${id}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          toast({
            type: "success",
            title: i18n.t("success.label"),
            description: "Job resumed Successfully ",
            animation: "bounce",
            time: 5000,
          });
        }
      }
    });
  };

  openDuplicate = (event) => {
    var id = event.target.id;
    this.setState({ modalOpenDuplicate: true });

    this.setState({
      msg_id: id,
    });
    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = {
      searchQuery: "",
      page: page_num,
      service_type: "profiled_sms",
    };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }
      var i;
      if (res.data.result.jobs != undefined) {
        for (i = 0; i < res.data.result.jobs.length; i++) {
          if (res.data.result.jobs[i].id === id) {
            var d = new Date(res.data.result.jobs[i].schedule_date),
              dformat =
                [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
                " " +
                [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
            //array.push({ date: dformat });

            this.setState({
              numberOfMessages: res.data.result.jobs[i].numberOfMessages,
              params: res.data.result.jobs[i].params,
              content: res.data.result.jobs[i].content,
              service_type: res.data.result.jobs[i].service_type,
              send_now: res.data.result.jobs[i].send_now,
              sender_id: res.data.result.jobs[i].sender_id,
              date: dformat,
              title: res.data.result.jobs[i].title,
            });
          }
        }
      }
    });
  };

  duplicate = () => {
    console.log(this.state.send_now);

    if (this.state.send_now === false) {
      var token = reactLocalStorage.get("accessToken");
      var defaultDate = new Date();
      if (this.state.date >= defaultDate) {
        if (this.state.content != "") {
          this.setState({ viewBoxSubmit: true });
          var d = this.state.date;
          var month = d.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          var hour = d.getHours();
          if (hour < 10) {
            hour = "0" + hour;
          }
          var date = d.getDate();
          if (date < 10) {
            date = "0" + date;
          }
          var minutes = d.getMinutes();
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          var dformat =
            [d.getFullYear(), month, date].join("-") +
            "T" +
            [hour, minutes, d.getSeconds() + "0"].join(":") +
            "Z";

            let currentComponent = this;
            var test = new Blob(
              [
                JSON.stringify({
                  numberOfMessages:this.state.numberOfMessages,
                  params:this.state.params,
                  content:this.state.content,
                  service_type:this.state.service_type,
                  send_now:this.state.send_now,
                  sender_id: this.state.sender_id,
                  schedule_date:dformat,
                 title:this.state.title
                  
                  
                }),
              ],
        
              { type: "application/json" }
            );
            data.append("object", test);
            this.setState({disableButtton:true})
            var token = reactLocalStorage.get("accessToken");
            var ip = API_BASE_URL;
            var s2 = "localhost:3000";
            var apiBaseUrl;
            if (ip.includes(s2)) {
              apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
            } else {
              apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
            }
           // var data = this.state.DuplicatedObject
            axios
              .post(apiBaseUrl, data, {
                headers: { "Content-Type": "multipart/form-data", token: token },
              })
              .then(response=>{
                currentComponent.setState({disableButtton:false})
                if (response.status === 200) {
                  var result = response.data.result;
                
                  if (
                    result != undefined &&
                    response.data.status == "send confirm!"
                  ) {
                    currentComponent.setState({
                      resultall: response.data.result.valid_numbers_count,
                    });
                    currentComponent.setState({confirm_id:response.data.result.confirm_id})
                    currentComponent.setState({
                      resultallinvalid:
                        response.data.result.invalid_numbers_count,
                    });
                    currentComponent.setState({
                      callbackDataValid: response.data.result.valid_numbers,
                    });
                    currentComponent.setState({
                      totalmsg: response.data.result.total_messages,
                    });
                    currentComponent.setState({
                      balance_reserved:
                        response.data.result.balance_reserved.profiled_sms,
                    });
                    currentComponent.setState({
                      callbackDataInValid: response.data.result.invalid_numbers,
                    });

                  currentComponent.setState({ viewBoxSubmit: false });

                  currentComponent.setState({ modalOpenConfirm: true });
                  currentComponent.setState({ confirm: result.confirm_id });
                } else {
                  toast({
                    type: "warning",
                    title: i18n.t("warning.label"),
                    description: response.data.status,
                    animation: "bounce",
                    time: 5000,
                  });
                  // document.getElementById("btn_back_step3").disabled = false;
                }
                data.delete("file");
                data.delete("object");
              }
            });
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_all_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      } else {
        if (this.state.content === "") {
          document.querySelector(".textarea_content").style =
            "border-color:red";
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_content_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        } else if (this.state.content != "") {
          this.setState({ viewBoxSubmit: true });
          var token = reactLocalStorage.get("accessToken");
          var d = new Date();
          console.log(d);
          var month = d.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          var hour = d.getHours();
          if (hour < 10) {
            hour = "0" + hour;
          }
          var date = d.getDate();
          if (date < 10) {
            date = "0" + date;
          }
          var minutes = d.getMinutes();
          if (minutes < 10) {
            minutes = "0" + minutes;
          }
          var dformat =
            [d.getFullYear(), month, date].join("-") +
            "T" +
            [hour, minutes, d.getSeconds() + "0"].join(":") +
            "Z";
  
            let currentComponent = this;
            var test = new Blob(
              [
                JSON.stringify({
                  numberOfMessages:this.state.numberOfMessages,
                  params:this.state.params,
                  content:this.state.content,
                  service_type:this.state.service_type,
                  send_now:this.state.send_now,
                  sender_id: this.state.sender_id,
                  schedule_date:dformat,
                  title:this.state.title
                  
                  
                }),
              ],
        
              { type: "application/json" }
            );
            this.setState({disableButtton:true})
            data.append("object", test);
            var token = reactLocalStorage.get("accessToken");
            var ip = API_BASE_URL;
            var s2 = "localhost:3000";
            var apiBaseUrl;
            if (ip.includes(s2)) {
              apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
            } else {
              apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
            }
           // var data = this.state.DuplicatedObject
            axios
              .post(apiBaseUrl, data, {
                headers: { "Content-Type": "multipart/form-data", token: token },
              })
              .then(response=> {
                currentComponent.setState({disableButtton:false})
                if (response.status === 200) {
                  var result = response.data.result;
                  
                  if (
                    result != undefined &&
                    response.data.status == "send confirm!"
                  ) {
                    currentComponent.setState({
                      resultall: response.data.result.valid_numbers_count,
                    });
                    currentComponent.setState({confirm_id:response.data.result.confirm_id})
                    currentComponent.setState({
                      resultallinvalid:
                        response.data.result.invalid_numbers_count,
                    });
                    currentComponent.setState({
                      callbackDataValid: response.data.result.valid_numbers,
                    });
                    currentComponent.setState({
                      totalmsg: response.data.result.total_messages,
                    });
                    currentComponent.setState({
                      balance_reserved:
                        response.data.result.balance_reserved.profiled_sms,
                    });
                    currentComponent.setState({
                      callbackDataInValid: response.data.result.invalid_numbers,
                    });
                    currentComponent.setState({viewBoxSubmit:false})
                    currentComponent.setState({ modalOpenConfirm: true });
                    currentComponent.setState({ confirm: result.confirm_id });
                  } else {
                    toast({
                      type: "warning",
                      title: i18n.t("warning.label"),
                      description: response.data.status,
                      animation: "bounce",
                      time: 5000,
                    });
                    // document.getElementById("btn_back_step3").disabled = false;
                  }
                  data.delete("file");
                  data.delete("object");
                }})
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_all_fields.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      }
    } else {
      if (this.state.content === "") {
        document.querySelector(".textarea_content").style = "border-color:red";
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_content_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      } else if (this.state.content != "") {
        this.setState({ viewBoxSubmit: true });
        var token = reactLocalStorage.get("accessToken");
        var d = new Date();
        console.log(d);
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var hour = d.getHours();
        if (hour < 10) {
          hour = "0" + hour;
        }
        var date = d.getDate();
        if (date < 10) {
          date = "0" + date;
        }
        var minutes = d.getMinutes();
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        var dformat =
          [d.getFullYear(), month, date].join("-") +
          "T" +
          [hour, minutes, d.getSeconds() + "0"].join(":") +
          "Z";

          let currentComponent = this;
          var test = new Blob(
            [
              JSON.stringify({
                numberOfMessages:this.state.numberOfMessages,
                params:this.state.params,
                content:this.state.content,
                service_type:this.state.service_type,
                send_now:this.state.send_now,
                sender_id: this.state.sender_id,
                schedule_date:dformat,
                title:this.state.title
                
                
              }),
            ],
      
            { type: "application/json" }
          );
          data.append("object", test);
          this.setState({disableButtton:true})
          var token = reactLocalStorage.get("accessToken");
          var ip = API_BASE_URL;
          var s2 = "localhost:3000";
          var apiBaseUrl;
          if (ip.includes(s2)) {
            apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
          } else {
            apiBaseUrl = API_BASE_URL + "/core/corpsms/sendSMS";
          }
         // var data = this.state.DuplicatedObject
          axios
            .post(apiBaseUrl, data, {
              headers: { "Content-Type": "multipart/form-data", token: token },
            })
            .then(response=> {
              currentComponent.setState({disableButtton:false})
              if (response.status === 200) {
                var result = response.data.result;
                console.log(this.state.viewBoxSubmit,"viewBoxSubmit")
                this.setState({viewBoxSubmit:false})
                if (
                  result != undefined &&
                  response.data.status == "send confirm!"
                ) {
                  currentComponent.setState({
                    resultall: response.data.result.valid_numbers_count,
                  });
                  currentComponent.setState({confirm_id:response.data.result.confirm_id})
                  currentComponent.setState({
                    resultallinvalid:
                      response.data.result.invalid_numbers_count,
                  });
                  currentComponent.setState({
                    callbackDataValid: response.data.result.valid_numbers,
                  });
                  currentComponent.setState({
                    totalmsg: response.data.result.total_messages,
                  });
                  currentComponent.setState({
                    balance_reserved:
                      response.data.result.balance_reserved.profiled_sms,
                  });
                  currentComponent.setState({
                    callbackDataInValid: response.data.result.invalid_numbers,
                  });
      
                  currentComponent.setState({ modalOpenConfirm: true });
                  currentComponent.setState({ confirm: result.confirm_id });
                } else {
                  toast({
                    type: "warning",
                    title: i18n.t("warning.label"),
                    description: response.data.status,
                    animation: "bounce",
                    time: 5000,
                  });
                  // document.getElementById("btn_back_step3").disabled = false;
                }
                data.delete("file");
                data.delete("object");
              }})
      } else {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      }
    }
  };

  Close() {
    this.setState({
      modalOpenBulkSMSStepOne: false,
      modalOpenBulkSMSStepTow: false,
      modalOpenConfirm: false,
      modalOpenBulkSMSStepHomeLocation: false,
      modalOpenBulkSMSStepWorkLocation: false,
      modalOpenBulkSMSStepVactionLocation: false,
      modalOpenBulkSMSStepOneNew: false,
    });
  }

  viewdata = (event) => {
    this.setState({ idRecord: event.target.id });
    this.setState({ modalOpenViewDetails: true });
    //document.querySelector(".fixed_header").style = "z-index:-1";

    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage_modal - 1;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        event.target.id +
        "/page=" +
        0 +
        "/getJobdetails";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        event.target.id +
        "/page=" +
        0 +
        "/getJobdetails";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ detailstotalpage: total });

      let result = res.data.result.result;

      if (res.data.result.result != undefined) {
        const Details = res.data.result.result;
        this.setState({ Details });
      }
    });
  };

  handlePaginationChangeactivePage_modal = (e, { activePage }) => {
    var x = this;
    x.setState({ activePage });
    console.log(
      "handlePaginationChangeactivePage_modal activePage",
      this.state.activePage
    );
    this.setState({ modalIsOpen: true });
    document.querySelector(".fixed_header").style = "z-index:-1";
    var token = reactLocalStorage.get("accessToken");
    var page_num = activePage - 1;
    console.log("handlePaginationChangeactivePage_modal",  page_num);

    
    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/page=" +
        page_num +
        "/getJobdetails";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/page=" +
        page_num +
        "/getJobdetails";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ totalpage: total });
      console.log("total page ", this.state.totalpage);
      let result = res.data.result.result;

      if (res.data.result.result != undefined) {
        const data = res.data.result.result;
        this.setState({ Details: data });

        this.forceUpdate();
      }
    });
  };

  searchchangepage = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    var data = { searchQuey: this.state.searchWord, page: activePage - 1 };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/searchJobdetails";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/jobs/user=" +
        reactLocalStorage.get("user_id_login") +
        "/job=" +
        this.state.idRecord +
        "/searchJobdetails";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      const data = res.data.result;

      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ searchdetailstotalpage: total });
      let result = res.data.result.result;

      if (res.data.result.result != undefined) {
        const persons = res.data.result.result;
        this.setState({ Details: persons });
      }
    });
  };

  searchchange = (event) => {
    this.setState({ searchword: event.target.value });
    if (event.target.value.length >= 2 || event.target.value == "") {
      document.querySelector(".detailspagination").style = "display:none";
      document.querySelector(".searchdetailspagination").style =
        "display:block";
      var token = reactLocalStorage.get("accessToken");
      var data = { searchQuey: event.target.value, page: 0 };

      var ip = API_BASE_URL;

      var s2 = "localhost:3000";

      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/jobs/user=" +
          reactLocalStorage.get("user_id_login") +
          "/job=" +
          this.state.idRecord +
          "/searchJobdetails";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/jobs/user=" +
          reactLocalStorage.get("user_id_login") +
          "/job=" +
          this.state.idRecord +
          "/searchJobdetails";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        const data = res.data.result;

        var total = Math.ceil(res.data.result.messages_count / 20);

        this.setState({ searchdetailstotalpage: total });

        let result = res.data.result.result;

        if (res.data.result.result != undefined) {
          const persons = res.data.result.result;
          this.setState({ Details: persons });
        }
      });
    }
  };

  export_details = (event) => {
    var x = this;
    x.setState({
      ViewBoxDetails: true,
    });
    var idRecord = this.state.idRecord;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_job_" + idRecord;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            x.export_detailsInterval();
            x.setState({ viewData: response.data.status });
          } else if (response.data.status === "ready to download") {
            x.setState({ viewData: response.data.status });

            var collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  export_detailsInterval = (event) => {
    var x = this;
    var idRecord = this.state.idRecord;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_job_" + idRecord;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    var callexport = setInterval(function() {
      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              x.setState({ viewData: response.data.status });
            } else if (response.data.status === "ready to download") {
              clearInterval(callexport);
              x.setState({ viewData: response.data.status });
              x.setState({
                ViewBoxDetails: true,
              });

              var collectionName = response.data.file_name;
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
              x.setState({
                ViewBoxDetails: false,
              });
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 3000);
  };

  render() {
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided className="fixed_bulk">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style yellow_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>

                  <br />
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />

                <Divider horizontal>
                  {" "}
                  <Header as="h2" color="black">
                    <Icon name="mail outline" color="black" /> Profiled SMS{" "}
                  </Header>{" "}
                </Divider>
                {this.state.displayViewBox && (
                  <div className="viewBox ">
                    <Message icon className="download_box">
                      <Icon name="circle notched" loading />
                      <Message.Content>
                        <Message.Header>Wait for downloading</Message.Header>
                        {this.state.viewData}
                      </Message.Content>
                    </Message>
                  </div>
                )}
                <br />

                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن المرسل "
                        : "Search By SenderID"
                    }
                    color="black"
                    onChange={this.searchchangemain.bind(this)}
                    style={{ float: "right" }}
                  />

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon
                      name="sort amount up"
                      onClick={this.handleOpenFilterDetails}
                    />{" "}
                    {i18n.t("filter.label")}
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentWillMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    disabled={this.state.exportFlag === false ? true : false}
                    size="small"
                    onClick={this.exportData}
                  >
                    <Icon name="file excel" /> {i18n.t("export.label")}
                  </Button>

                  {reactLocalStorage.get("role") === "ROLE_ADMIN" ||
                  reactLocalStorage.get("role") === "ROLE_SUBADMIN" ? (
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={() => {
                        this.goToAddProfiledSMS();
                      }}
                    >
                      {this.state.isArabic
                        ? "Profiled انشاء رسالة"
                        : "Compose Profiled SMS"}

                      <Icon
                        color="black"
                        name="pencil alternate"
                        color="black"
                      />
                    </Button>
                  ) : (
                    ""
                  )}

                  {reactLocalStorage.get("packageID") === "1692" ? null : (
                    <Button.Group>
                      <Button color="teal" basic>
                        <Icon name="bell" />
                        {this.state.isArabic
                          ? "الرصيد المتبقي"
                          : "Remaining Balance"}
                      </Button>
                      {this.state.isArabic ? (
                        <Button color="teal">
                          {commaNumber(this.state.profiled_balance) != null
                            ? commaNumber(this.state.profiled_balance) +
                              " رسالة "
                            : "-"}
                        </Button>
                      ) : (
                        <Button color="teal">
                          {commaNumber(this.state.profiled_balance) != null
                            ? commaNumber(this.state.profiled_balance) + " SMS"
                            : "-"}
                        </Button>
                      )}
                    </Button.Group>
                  )}

                  {/*  <Menu compact>
                    <Menu.Item>
                      <Icon name="bell" />{" "}
                      {this.state.isArabic
                        ? "الرصيد المتبقي"
                        : "Remaining Balance"}
                      <Label color="teal" floating>
                        {commaNumber(this.state.profiled_balance)}
                      </Label>
                    </Menu.Item>
                  </Menu> */}
                </div>

                <br />
                <br />
                <br />
                {/*   <Transition
                  visible={visible}
                  animation="slide down"
                  duration={500}
                >
                  <Segment>
                    <Image
                      size="small"
                      src="https://react.semantic-ui.com/images/leaves/1.png"
                    />
                  </Segment>
                </Transition> */}
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <th>{i18n.t("job_title.label")}</th>
                      <th>{i18n.t("sender_id.label")}</th>
                      <th>{i18n.t("numberofmsgs.label")}</th>
                      <th>{i18n.t("total_recipients.label")} </th>
                      <th>{i18n.t("total_delievered.label")}</th>
                      <th>{i18n.t("total_failed.label")}</th>
                      <th>{i18n.t("Status.label")}</th>
                      <th>{i18n.t("Schedule_date.label")}</th>
                      <th>{i18n.t("content.label")}</th>
                      <th>{i18n.t("view_details.label")}</th>
                    </tr>
                  </thead>
                  <tbody response>
                    {this.state.data.map((person) => (
                      <tr>
                        <td>{person.title} </td>
                        <td>{person.sender_id}</td>
                        <td>{commaNumber(person.total_messages)} </td>
                        <td>{commaNumber(person.total_recipients)}</td>
                        <td>{commaNumber(person.total_delievered)}</td>
                        <td>{commaNumber(person.total_rejected)}</td>
                        <td> {person.status}</td>
                        <td>
                          {person.schedule_date
                            ? this.test(person.schedule_date)
                            : ""}
                        </td>
                        <td>{person.content}</td>
                        <td>
                          {reactLocalStorage.get("role") == "ROLE_OPERATOR" ||
                          reactLocalStorage.get("role") ==
                            "ROLE_OPERATOR_INT" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.viewdata}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="eye"
                                  className="eye"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "عرض" : "View"}
                              </Button>
                              <br></br>
                            </div>
                          ) : null}{" "}
                          {person.status === "completed" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                disabled={person.params === null ? true : false}
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.openDuplicate}
                                style={{ width: "120px" }}
                              >
                                <Icon name="redo" id={person.id} />
                                {this.state.isArabic ? "تكرار" : "Duplicated"}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {person.status === "stopped" ? "" : ""}
                          {person.status === "cancelled" ? "" : ""}
                          {person.status == "scheduled" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.stopJob}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="times circle outline"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "إلغاء" : "Cancel"}
                              </Button>
                              <br />
                              <br />
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={(event) => {
                                  this.openEdit(event);
                                }}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="edit circle outline"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "تعديل" : "Edit"}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {person.status === "running" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.stopJob}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="times circle outline "
                                  id={person.id}
                                />
                                {this.state.isArabic ? "إلغاء" : "stop"}
                              </Button>
                              <br />
                              <br />
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.pauseJob}
                                style={{ width: "120px" }}
                              >
                                <Icon name="pause" id={person.id} />
                                {this.state.isArabic ? "إيقاف" : "pause"}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {person.status === "sent" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                disabled={person.params === null ? true : false}
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.openDuplicate}
                                style={{ width: "120px" }}
                              >
                                <Icon name="redo" id={person.id} />
                                {this.state.isArabic ? "تكرار" : "Duplicated"}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {person.status === "paused" ? (
                            <div>
                              <Button
                                floated="right"
                                icon
                                labelPosition="left"
                                basic
                                color="black"
                                size="mini"
                                id={person.id}
                                onClick={this.resumeJob}
                                style={{ width: "120px" }}
                              >
                                <Icon
                                  name="caret square right"
                                  id={person.id}
                                />
                                {this.state.isArabic ? "إعادة تشغيل" : "resume"}
                              </Button>
                              <br />
                              <br />
                            </div>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <br />

                <br />
                <br />
                <div className="bulkpagination">
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.bulktotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>

                <div
                  className="searchbulkpagination"
                  style={{ display: "none" }}
                >
                  <Segment basic />

                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChangeSearchBasic}
                        totalPages={this.state.searchbulktotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>

                <div className="filterpagination" style={{ display: "none" }}>
                  <Segment basic />

                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationFilterChange}
                        totalPages={this.state.filterTotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
              </Segment>
            </div>
          </div>
          {/* ////////////////////////////////////////Modals////////////////////////////////////// */}
          <Modal
            size="large"
            open={this.state.modalOpenViewDetails}
            onClose={this.handleCloseViewDetails}
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            className="filter"
            style={this.state.isArabic ? modDetailsa : modDetails}
          >
            <Header
              icon="clipboard outline"
              content={i18n.t("Details.label")}
            />

            <Modal.Content scrolling>
              <div className="buttonsHeader">
                <Input
                  size="small"
                  icon="search"
                  placeholder={i18n.t("search.label")}
                  style={{ float: "right" }}
                  onChange={this.searchchange.bind(this)}
                />

                <Button
                  floated="right"
                  icon
                  labelPosition="left"
                  basic
                  size="small"
                  onClick={this.export_details.bind(this, this.state.idRecord)}
                >
                  {i18n.t("export_details.label")}
                  <Icon name="file excel" color="black" />
                </Button>
                <br />
              </div>
              {this.state.ViewBoxDetails && (
                <div className="viewDetails">
                  <Message icon className="download_details_box">
                    <Icon name="circle notched" loading />
                    <Message.Content>
                      <Message.Header>Wait for downloading</Message.Header>
                      {this.state.viewData}
                    </Message.Content>
                  </Message>
                </div>
              )}
              <br />
              <br />

              <Table
                hover
                responsive
                border="0"
                style={{ textAlign: this.state.isArabic ? "right" : "left" }}
              >
                <thead className="head">
                  <tr>
                    <th colSpan="7" style={{ maxWidth: "35px" }}>
                      {i18n.t("Message.label")}
                    </th>
                    <th colSpan="2">{i18n.t("Mobile_Number.label")}</th>

                    <th>{i18n.t("Status.label")}</th>
                    <th>{i18n.t("Schedule_date.label")}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.Details.map((person) => (
                    <tr>
                      <td colSpan="7" style={{ maxWidth: "25px" }}>
                        {person.message_Content}
                      </td>
                      <td colSpan="2">{person.reciepint_number}</td>

                      <td>{person.delivery_status}</td>
                      <td>{person.send_time}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <br />
                  <div
                    className="detailspagination"
                    style={{ textAlign: "center" }}
                  >
                    {" "}
                    <Header as="h5" floated="right">
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={
                          this.handlePaginationChangeactivePage_modal
                        }
                        totalPages={this.state.detailstotalpage}
                        style={{ float: this.state.isArabic ? "left" : "" }}
                      />
                    </Header>
                  </div>

                  <div
                    className="searchdetailspagination"
                    style={{ display: "none" }}
                  >
                    {" "}
                    <Header as="h5" floated="right">
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.searchchangepage}
                        totalPages={this.state.searchdetailstotalpage}
                        style={{ float: this.state.isArabic ? "left" : "" }}
                      />
                    </Header>
                  </div>
                </tfoot>
              </Table>
            </Modal.Content>

            <Modal.Actions>
              <Button
                color="black"
                content={i18n.t("Close.label")}
                onClick={this.handleCloseViewDetails}
              />
            </Modal.Actions>
          </Modal>
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenBulkSMSStepOne}
            onClose={this.handleCloseBulkSMSStepOne}
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            size="medium"
            className="add"
          >
            <Header icon="pencil alternate" content=" Add Profiled SMS" />

            <Modal.Content scrolling>
              <Modal.Description scrolling>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Form>
                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      float:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                      fontSize: "16px",
                    }}
                  >
                    {i18n.t("Title.label")}
                  </label>

                  <input
                    required="required"
                    type="text"
                    className="form-control title_data"
                    value={this.state.title}
                    name="name"
                    onChange={this.handleChangeTitle}
                  />
                  <br />

                  <p
                    className="h6 black_color"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  >
                    {i18n.t("Sender_ID.label")}
                  </p>
                  <Select
                    placeholder={i18n.t("select.label")}
                    search
                    selection
                    options={this.state.countryOptions}
                    onChange={this.onChangesenderid.bind(this)}
                    style={{ width: "100%" }}
                  />
                  <br />
                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      float:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                      fontSize: "16px",
                    }}
                  >
                    {i18n.t("TargetCustomers.label")}
                  </label>
                  <input
                    required="required"
                    type="number"
                    className="form-control title_data"
                    value={this.state.numberOfMessages}
                    name="numberOfMessages"
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === "" || re.test(e.target.value)) {
                        this.setState({ numberOfMessages: e.target.value });
                      }
                    }}
                  />
                  <br />

                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      float:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                      fontSize: "16px",
                    }}
                  >
                    {this.state.isArabic
                      ? "اختر ملف الأرقام"
                      : "Choose Your Numbers File"}
                  </label>
                  <input
                    type="file"
                    // className="form-control input_file"
                    name="mobile"
                    required="required"
                    onChange={this.handleChangeupload}
                    //key={this.state.inputKey}
                  />
                  <br />
                </Form>
                <br /> <br />
              </Modal.Description>
            </Modal.Content>

            <Modal.Actions>
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={() => {
                  this.close();
                }}
              />
              <Button
                basic
                color="teal"
                onClick={() => {
                  this.openstep2();
                }}
              >
                {i18n.t("Next.label")} <Icon name="right chevron" />
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenBulkSMSStepOneNew}
            onClose={this.handleCloseBulkSMSStepOneNew}
            size="medium"
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
          >
            <Header icon="pencil alternate" content=" Add Profiled SMS" />
            <Modal.Content>
              <Modal.Description>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Header as="h4" color="grey" dividing>
                  {" "}
                  <Icon name="pie graph" /> Demographics
                </Header>{" "}
                <span>Age</span>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group />
                        <Form.Group inline>
                          <Checkbox
                            label="Less than 18"
                            value="<18"
                            id="<18"
                            onClick={(event) => {
                              this.addAge(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group />
                        <Form.Group inline>
                          <Checkbox
                            label="18-24"
                            value="18<=AGE<24"
                            id="18<=AGE<24"
                            onClick={(event) => {
                              this.addAge(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group />
                        <Form.Group inline>
                          <Checkbox
                            label="24-30"
                            value="24<=AGE<30"
                            id="24<=AGE<30"
                            onClick={(event) => {
                              this.addAge(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group />
                        <Form.Group inline>
                          <Checkbox
                            label="30-40"
                            value="30<=AGE<40"
                            id="30<=AGE<40"
                            onClick={(event) => {
                              this.addAge(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group />
                        <Form.Group inline>
                          <Checkbox
                            label="More than 40"
                            value=">=40"
                            id=">=40"
                            onClick={(event) => {
                              this.addAge(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <br />
                <br />
                <br />
                <Divider />
                <span> Gender</span>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="Female"
                            value="FEMALE"
                            id="FEMALE"
                            onClick={(event) => {
                              this.addGender(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="Male"
                            value="MALE"
                            id="MALE"
                            onClick={(event) => {
                              this.addGender(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {/* <Header as="h4" color="grey" dividing>
                  <Icon name="payment" /> Package Type{" "}
                </Header>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="Prepaid"
                            value="PREPAID"
                            id="PREPAID"
                            onClick={(event) => {
                              this.addPacakegeType(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="PostPaid"
                            value="POSTPAID"
                            id="POSTPAID"
                            onClick={(event) => {
                              this.addPacakegeType(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Header as="h4" color="grey" dividing>
                  <Icon name="chart area" />
                  Spending Behavior{" "}
                </Header>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="High"
                            value="HIGH"
                            id="HIGH"
                            onClick={(event) => {
                              this.addSpending(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="Average"
                            value="Average"
                            id="AVERAGE"
                            onClick={(event) => {
                              this.addSpending(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid> */}
                <Header as="h4" color="grey" dividing>
                  {" "}
                  <Icon name="android" /> Handset OS{" "}
                </Header>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="Android"
                            value="ANDROID"
                            id="ANDROID"
                            onClick={(event) => {
                              this.addDevicePlatform(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="IOS"
                            value="IOS"
                            id="IOS"
                            onClick={(event) => {
                              this.addDevicePlatform(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="Others"
                            value="OTHERS"
                            id="DeviceOTHERS"
                            onClick={(event) => {
                              this.addDevicePlatform(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {/**This Hide on 30 OCT 2024 Based on Mohd Odeh Request */}
                {/**  <Header as="h4" color="grey" dividing>
                  {" "}
                  <Icon name="settings" /> Handset Type {" "}
                </Header>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="HUAWEI"
                            value="HUAWEI"
                            id="HUAWEI"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="SAMSUNG"
                            value="SAMSUNG"
                            id="SAMSUNG"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="NOKIA"
                            value="NOKIA"
                            id="NOKIA"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="APPEL"
                            value="APPEL"
                            id="APPEL"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="LG"
                            value="LG"
                            id="LG"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>

                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="BLACKBERRY"
                            value="BLACKBERRY"
                            id="BLACKBERRY"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="ALCATEL"
                            value="ALCATEL"
                            id="ALCATEL"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="SONY"
                            value="SONY"
                            id="SONY"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="HTC"
                            value="HTC"
                            id="HTC"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Form>
                        <Form.Group inline>
                          <Checkbox
                            label="Others"
                            value="OTHERS"
                            id="OTHERS"
                            onClick={(event) => {
                              this.addManufacturer(event);
                            }}
                          />
                        </Form.Group>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid> */}
              </Modal.Description>
            </Modal.Content>
            <br />
            <br />
            <br />
            <br />
            <br />
            <Modal.Actions>
              <Button
                basic
                color="black"
                onClick={() => {
                  this.goBackOne();
                }}
              >
                {" "}
                <Icon name="left chevron" /> {i18n.t("Back.label")}
              </Button>

              <Button
                basic
                color="teal"
                onClick={this.handleOpenBulkSMSStepHomeLocation}
                /*  onClick={ reactLocalStorage.get("role") === "ROLE_ADMIN" ||
                reactLocalStorage.get("role") === "ROLE_SUBADMIN"  ? this.handleOpenBulkSMSSteptTow: this.handleOpenBulkSMSStepHomeLocation} */
              >
                {" "}
                {i18n.t("Next.label")} <Icon name="right chevron" />
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            open={this.state.modalOpenBulkSMSStepHomeLocation}
            onClose={this.handleCloseBulkSMSStepHomeLocation}
            size="medium"
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
          >
            <Header icon="pencil alternate" content=" Add Profiled SMS" />

            <Modal.Description>
              <Modal.Content style={{ padding: "10px" }} scrolling>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>

                <HomeLocation
                  parentHomeGoverCallback={this.addHomeGover}
                  parentHomeDistrictCallback={this.addHomeDistrict}
                  parentHomeAreaCallback={this.addHomeArea}
                  parentHomeLogicCallback={this.addLogic}
                />
              </Modal.Content>
            </Modal.Description>

            <Modal.Actions>
              <Button
                basic
                color="black"
                onClick={() => {
                  this.goBackTow();
                }}
              >
                {" "}
                <Icon name="left chevron" /> {i18n.t("Back.label")}
              </Button>

              <Button
                basic
                color="teal"
                onClick={this.handleOpenBulkSMSStepWorkLocation}
              >
                {" "}
                {i18n.t("Next.label")} <Icon name="right chevron" />
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenBulkSMSStepWorkLocation}
            onClose={this.handleCloseBulkSMSStepWorkLocation}
            size="medium"
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
          >
            <Header icon="pencil alternate" content=" Add Profiled SMS" />

            <Modal.Description>
              <Modal.Content style={{ padding: "10px" }} scrolling>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <WorkLocation
                  parentWorkGoverCallback={this.addWorkGover}
                  parentWorkDistrictCallback={this.addWorkDistrict}
                  parentWorkAreaCallback={this.addWorkArea}
                />
              </Modal.Content>
            </Modal.Description>

            <Modal.Actions>
              <Button
                basic
                color="black"
                onClick={() => {
                  this.goBackThree();
                }}
              >
                {" "}
                <Icon name="left chevron" /> {i18n.t("Back.label")}
              </Button>

              <Button
                basic
                color="teal"
                onClick={this.handleOpenBulkSMSStepVacationLocation}
              >
                {" "}
                {i18n.t("Next.label")} <Icon name="right chevron" />
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            open={this.state.modalOpenBulkSMSStepVactionLocation}
            onClose={this.handleCloseBulkSMSStepVacationLocation}
            size="medium"
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
          >
            <Header icon="pencil alternate" content=" Add Profiled SMS" />

            <Modal.Description>
              <Modal.Content style={{ padding: "10px" }} scrolling>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <VacationLocation
                  parentVacationGoverCallback={this.addVacationGover}
                  parentVacationDistrictCallback={this.addVacationDistrict}
                  parentVacationAreaCallback={this.addVacationArea}
                />
              </Modal.Content>
            </Modal.Description>

            <br />
            <br />
            <Modal.Actions>
              <Button
                basic
                color="black"
                onClick={() => {
                  this.goBackFour();
                }}
              >
                {" "}
                <Icon name="left chevron" /> {i18n.t("Back.label")}
              </Button>

              <Button
                basic
                color="teal"
                onClick={this.handleOpenBulkSMSSteptTow}
              >
                {" "}
                {i18n.t("Next.label")} <Icon name="right chevron" />
              </Button>
            </Modal.Actions>
          </Modal>
          {/* ///////////////////////////////////////////safi/////////////////////////////////// */}
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenBulkSMSStepTow}
            onClose={this.handleCloseBulkSMSStepTow}
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
            size="medium"
          >
            <Header icon="pencil alternate" content=" Add Profiled SMS" />

            <Modal.Content scrolling>
              <Modal.Description scrolling>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Form>
                  <p
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                      fontSize: "16px",
                    }}
                  >
                    {i18n.t("Select_Time.label")}
                  </p>
                  <Select
                    options={this.state.time}
                    onChange={this.onChangetime.bind(this)}
                    defaultValue={this.state.timeselect}
                    placeholder={this.state.timeselect}
                  />
                  <br />
                  <span
                    className="templates-class"
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Template.label")}
                    </p>

                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      search
                      selection
                      options={template}
                      onChange={this.onChangetemplate.bind(this)}
                    />
                  </span>
                  <br />
                  <div className="time_div" style={{ display: "none" }}>
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                      style={{
                        width: "100%",
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Time.label")}
                    </p>
                    <DateTime
                      onChange={this.onChangedatetime}
                      value={this.state.date}
                      className="test"
                      closeOnSelect={true}
                      closeOnTab={true}
                      locale={i18n.language}
                      isValidDate={valid}
                    />

                    {/* <DateTimePicker
                    onChange={this.onChangedatetime}
                    value={this.state.date}
                    firstDayOfWeek={1}
                  /> */}
                    <br />
                    <br />
                  </div>

                  <span
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light content_label templates-class"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Content.label")}
                    </p>
                    <Button
                      className="add_variable_btn"
                      style={{ display: "none" }}
                      onClick={this.addVariables}
                    >
                      {i18n.t("Add_variables.label")}
                    </Button>

                    <textarea
                      className="form-control templates-class textarea_content"
                      id="contentArea"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeContent}
                      value={this.state.content}
                    />

                    <span
                      class="textarea__countar"
                      style={{ float: "right", display: "none" }}
                    >
                      {this.state.content.length}/
                      {/* {Math.ceil(this.state.content.length / 70)} */}
                      {this.state.numberOfMessagesContent}
                      {/*  ////////////// number of arabic messages /////////////// */}
                    </span>
                    <span
                      class="textarea__countar_varaibles"
                      style={{ float: "right", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>

                    <span class="textarea__counten" style={{ float: "right" }}>
                      {this.state.content.length}/
                      {this.state.numberOfMessagesContent}
                    </span>

                    <span
                      class="textarea__counten_varaibles"
                      style={{ float: "left", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>
                  </span>
                  {/* <br />
                 
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showMobigram}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Mobigram
                    </span>
                    <Icon color="black" name="text height" color="black" />
                  </Button> */}

                  <br />
                  <br />
                  <div
                    style={{ border: "1px solid gainsboro", display: "none" }}
                    className="mobigram"
                  >
                    <EditorConvertToHTML
                      parentCallback={this.handleSubmitEditor}
                      loading={this.state.loading}
                    />
                  </div>
                  <br />
                  <br />
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showRecurring}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Recurring SMS
                    </span>
                    <Icon color="black" name="redo alternate" color="black" />
                  </Button>

                  <br />
                  <br />

                  <div className="recurring" style={{ display: "none" }}>
                    <br />

                    <table>
                      <tr>
                        <td style={{ width: "90%" }}>
                          <DateTime
                            onChange={this.onChangedatetimerecurring}
                            value={this.state.recurring}
                            className="test"
                            //closeOnSelect={true}
                            closeOnTab={true}
                            locale={i18n.language}
                            id="candidate"
                          />
                        </td>
                        <td>
                          <Button
                            floated="left"
                            icon
                            labelPosition="left"
                            basic
                            size="small"
                            onClick={() => {
                              this.handleDayClick();
                            }}
                          >
                            <Icon name="plus" />
                            Add
                          </Button>
                        </td>
                      </tr>
                    </table>

                    <br />

                    <br />
                    <div className="viewTable" style={{ display: "none" }}>
                      {this.state.view.map((date, index) => (
                        <Segment basic color="teal" padded>
                          {date}
                          <Button
                            basic
                            content="Delete Date"
                            icon="delete calendar"
                            labelPosition="right"
                            floated="right"
                            id={index}
                            onClick={() => {
                              this.removeItem(index);
                            }}
                          />

                          <br />

                          <br />
                        </Segment>
                      ))}

                      <br />
                      <br />
                    </div>
                  </div>
                </Form>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="black"
                onClick={() => {
                  this.goBackFive();
                }}
              >
                {" "}
                <Icon name="left chevron" /> {i18n.t("Back.label")}
              </Button>

              <Button
                basic
                color={this.state.viewBoxSubmit ? "red" : "teal"}
                onClick={this.state.disableButtton ? null : this.submit}
              >
                {this.state.viewBoxSubmit == false ? (
                  <div>
                    {i18n.t("Next.label")} <Icon name="right chevron" />
                  </div>
                ) : (
                  <div>
                    <Icon name="circle notched" loading />
                    Collecting Data...
                  </div>
                )}
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenConfirm}
            onClose={this.handleCloseConfirm}
            size="medium"
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
          >
            <Header icon="pencil alternate" content=" Add Profiled SMS" />
            <Modal.Content>
              <Modal.Description>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Form
                  style={{
                    textAlign:
                      reactLocalStorage.get("lang") === "ar" ? "right" : "left",
                  }}
                >
                  <Form.Input
                    label={i18n.t("totalmsg.label")}
                    value={commaNumber(this.state.totalmsg)}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  <Form.Input
                    label={i18n.t("totalValid_Number.label")}
                    value={commaNumber(this.state.resultall)}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  <Form.Input
                    label={i18n.t("totalinValid_Number.label")}
                    value={commaNumber(this.state.resultallinvalid)}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  {/* <Form.Input
                    label={i18n.t("balance_reserved.label")}
                    value={this.state.balance_reserved}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  /> */}
                  <div
                    style={{
                      display: this.state.confirm_id === "" ? "block" : "none",
                    }}
                  >
                    <Segment basic style={{ paddingTop: "6px" }}>
                      <Header as="h3" color="grey">
                        <Icon name="warning sign" loading />

                        <Header.Content>
                          Please wait your admin to approve your request, You
                          can leave the page now..
                        </Header.Content>
                      </Header>
                    </Segment>
                  </div>
                </Form>
              </Modal.Description>
            </Modal.Content>

            <Modal.Actions>
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseConfirm}
              />
              <Button
                basic
                color="teal"
                content={i18n.t("Confirm.label")}
                onClick={this.confirm_msg}
                id="confirm_sms"
                disabled={this.state.confirm_id === "" ? true : false}
              />
              <Button
                basic
                color="teal"
                content={i18n.t("Close.label")}
                onClick={() => {
                  this.Close();
                }}
                disabled={this.state.confirm_id === "" ? false : true}
              />
            </Modal.Actions>
          </Modal>
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            size="tiny"
            open={this.state.modalOpenStopJop}
            onClose={this.handleCloseStopJop}
            style={this.state.isArabic ? modStopa : modStop}
            className="filter"
          >
            <Header icon="warning circle" content={i18n.t("cancel.label")} />
            <Modal.Content>
              <Header as="h3" textAlign="center">
                {" "}
                {i18n.t("Are_you_sure_about_stopping_the_job.label")}
              </Header>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Yes.label")}
                onClick={this.confirmStop}
              />
              <Button
                basic
                color="black"
                content={i18n.t("No.label")}
                onClick={this.handleCloseStopJop}
              />
            </Modal.Actions>
          </Modal>
          {/* ////////////////////////////////// filter////////////////////////////////
           */}{" "}
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenFilterDetails}
            onClose={this.handleCloseFilterDetails}
            className="add"
            style={this.state.isArabic ? filtera : filter}
          >
            <Header content="Filter" icon="sort amount up" />
            <Modal.Content scrolling>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                {i18n.t("start_date.label")}
              </label>
              <br />
              <input
                type="date"
                onChange={this.onChangeFromDate}
                className="dateinput"
              />

              <br />

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                <br />
                {i18n.t("end_date.label")}
              </label>
              {/*type="datetime-local" */}
              <input
                type="date"
                onChange={this.onChangeToDate}
                className="dateinput"
              />

              <br />
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={() => {
                  this.filterData();
                }}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseFilterDetails}
              />
            </Modal.Actions>
          </Modal>
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenBulkEdit}
            onClose={this.handleCloseBulkEdit}
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
            size="medium"
          >
            <Header icon="edit outline" content="Edit Profiled SMS" />

            <Modal.Content scrolling>
              <Modal.Description>
                <Form>
                  <p
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                      fontSize: "16px",
                    }}
                  >
                    {i18n.t("Select_Time.label")}
                  </p>
                  <Select
                    options={this.state.time}
                    onChange={this.onChangetime.bind(this)}
                    defaultValue={this.state.timeselect}
                    placeholder={this.state.timeselect}
                  />
                  <br />
                  <span
                    className="templates-class"
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Template.label")}
                    </p>

                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      search
                      selection
                      options={template}
                      onChange={this.onChangetemplate.bind(this)}
                    />
                  </span>
                  <br />
                  <div className="time_div" style={{ display: "none" }}>
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                      style={{
                        width: "100%",
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Time.label")}
                    </p>
                    <DateTime
                      onChange={this.onChangedatetime}
                      value={this.state.date}
                      className="test"
                      closeOnSelect={true}
                      closeOnTab={true}
                      locale={i18n.language}
                      isValidDate={valid}
                    />

                    <br />
                    <br />
                  </div>

                  <span
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light content_label templates-class"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Content.label")}
                    </p>
                    <Button
                      className="add_variable_btn"
                      style={{ display: "none" }}
                      onClick={this.addVariables}
                    >
                      {i18n.t("Add_variables.label")}
                    </Button>

                    <textarea
                      className="form-control templates-class textarea_content"
                      id="contentArea"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeContent}
                      value={this.state.content}
                    />

                    <span
                      class="textarea__countar"
                      style={{ float: "right", display: "none" }}
                    >
                      {this.state.content.length}/
                      {/* {Math.ceil(this.state.content.length / 70)} */}
                      {this.state.numberOfMessagesContent}
                      {/*  ////////////// number of arabic messages /////////////// */}
                    </span>
                    <span
                      class="textarea__countar_varaibles"
                      style={{ float: "right", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>

                    <span class="textarea__counten" style={{ float: "right" }}>
                      {this.state.content.length}/
                      {this.state.numberOfMessagesContent}
                    </span>

                    <span
                      class="textarea__counten_varaibles"
                      style={{ float: "left", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>
                  </span>
                  <br />
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showMobigram}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Mobigram
                    </span>
                    <Icon color="black" name="text height" color="black" />
                  </Button>

                  <br />
                  <br />
                  <div
                    style={{ border: "1px solid gainsboro", display: "none" }}
                    className="mobigram"
                  >
                    <EditorConvertToHTML
                      parentCallback={this.handleSubmitEditor}
                      loading={this.state.loading}
                    />
                  </div>
                </Form>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button basic color="black" onClick={this.handleCloseBulkEdit}>
                {" "}
                {i18n.t("Cancel.label")}
              </Button>
              <Button
                basic
                color="teal"
                onClick={() => {
                  this.submitEdit();
                }}
              >
                {i18n.t("Submit.label")}
              </Button>
            </Modal.Actions>
          </Modal>
          {/* //////////////////////////////// Duplicate ///////////////////////////////// */}
          <Modal
            closeIcon={{
              style: { top: "0rem", right: "0rem" },
              color: "black",
              name: "close",
            }}
            open={this.state.modalOpenDuplicate}
            onClose={this.handleCloseDuplicate}
            style={this.state.isArabic ? StepOneModala : StepOneModal2}
            className="add"
            size="medium"
          >
            <Header icon="redo" content="Duplicate Profiled SMS" />

            <Modal.Content scrolling>
              <Modal.Description scrolling>
                <Header>
                  <Step.Group widths={5} ordered>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {this.state.isArabic
                            ? "معلومات الرسائل"
                            : "SMS Information"}{" "}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "فئات الرسائل"
                            : "SMS Categories"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step active>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "إدارة الرسائل"
                            : "SMS Managment"}
                        </Step.Title>
                      </Step.Content>
                    </Step>

                    <Step disabled>
                      <Step.Content>
                        <Step.Title>
                          {" "}
                          {this.state.isArabic
                            ? "تأكيد العملية"
                            : "Process Confirmtion"}
                        </Step.Title>
                      </Step.Content>
                    </Step>
                  </Step.Group>
                  <br />
                </Header>
                <Form>
                  <p
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                      fontSize: "16px",
                    }}
                  >
                    {i18n.t("Select_Time.label")}
                  </p>
                  <Select
                    options={this.state.time}
                    onChange={this.onChangetime.bind(this)}
                    defaultValue={this.state.timeselect}
                    placeholder={this.state.timeselect}
                  />
                  <br />
                  <span
                    className="templates-class"
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Template.label")}
                    </p>

                    <Select
                      placeholder={i18n.t("select.label")}
                      fluid
                      search
                      selection
                      options={template}
                      onChange={this.onChangetemplate.bind(this)}
                    />
                  </span>
                  <br />
                  <div className="time_div" style={{ display: "none" }}>
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light"
                      style={{
                        width: "100%",
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Time.label")}
                    </p>
                    <DateTime
                      onChange={this.onChangedatetime}
                      value={this.state.date}
                      className="test"
                      closeOnSelect={true}
                      closeOnTab={true}
                      locale={i18n.language}
                      isValidDate={valid}
                    />

                    {/* <DateTimePicker
                    onChange={this.onChangedatetime}
                    value={this.state.date}
                    firstDayOfWeek={1}
                  /> */}
                    <br />
                    <br />
                  </div>

                  <span
                    style={{
                      display:
                        this.state.typeofMSg === "dynamic_file"
                          ? "none "
                          : "block",
                    }}
                  >
                    <p
                      htmlFor="defaultFormCardNameEx"
                      className="grey-text font-weight-light content_label templates-class"
                      style={{
                        textAlign:
                          reactLocalStorage.get("lang") === "ar"
                            ? "right"
                            : "left",
                        fontSize: "16px",
                      }}
                    >
                      {i18n.t("Content.label")}
                    </p>
                    <Button
                      className="add_variable_btn"
                      style={{ display: "none" }}
                      onClick={this.addVariables}
                    >
                      {i18n.t("Add_variables.label")}
                    </Button>

                    <textarea
                      className="form-control templates-class textarea_content"
                      id="contentArea"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeContent}
                      value={this.state.content}
                    />

                    <span
                      class="textarea__countar"
                      style={{ float: "right", display: "none" }}
                    >
                      {this.state.content.length}/
                      {/* {Math.ceil(this.state.content.length / 70)} */}
                      {this.state.numberOfMessagesContent}
                      {/*  ////////////// number of arabic messages /////////////// */}
                    </span>
                    <span
                      class="textarea__countar_varaibles"
                      style={{ float: "right", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>

                    <span class="textarea__counten" style={{ float: "right" }}>
                      {this.state.content.length}/
                      {this.state.numberOfMessagesContent}
                    </span>

                    <span
                      class="textarea__counten_varaibles"
                      style={{ float: "left", display: "none" }}
                    >
                      {i18n.t("count_variable.label")} :{count}
                    </span>
                  </span>
                  <br />
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showMobigram}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Mobigram
                    </span>
                    <Icon color="black" name="text height" color="black" />
                  </Button>

                  <br />
                  <br />
                  <div
                    style={{ border: "1px solid gainsboro", display: "none" }}
                    className="mobigram"
                  >
                    <EditorConvertToHTML
                      parentCallback={this.handleSubmitEditor}
                      loading={this.state.loading}
                    />
                  </div>
                  <br />
                  <br />
                  <Button
                    floated="left"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showRecurring}
                  >
                    <span
                      style={{ fontWeight: "bold", color: "black" }}
                      id="demo"
                    >
                      {" "}
                      Recurring SMS
                    </span>
                    <Icon color="black" name="redo alternate" color="black" />
                  </Button>

                  <br />
                  <br />

                  <div className="recurring" style={{ display: "none" }}>
                    <br />

                    <table>
                      <tr>
                        <td style={{ width: "90%" }}>
                          <DateTime
                            onChange={this.onChangedatetimerecurring}
                            value={this.state.recurring}
                            className="test"
                            //closeOnSelect={true}
                            closeOnTab={true}
                            locale={i18n.language}
                            id="candidate"
                          />
                        </td>
                        <td>
                          <Button
                            floated="left"
                            icon
                            labelPosition="left"
                            basic
                            size="small"
                            onClick={() => {
                              this.handleDayClick();
                            }}
                          >
                            <Icon name="plus" />
                            Add
                          </Button>
                        </td>
                      </tr>
                    </table>

                    <br />

                    <br />
                    <div className="viewTable" style={{ display: "none" }}>
                      {this.state.view.map((date, index) => (
                        <Segment basic color="teal" padded>
                          {date}
                          <Button
                            basic
                            content="Delete Date"
                            icon="delete calendar"
                            labelPosition="right"
                            floated="right"
                            id={index}
                            onClick={() => {
                              this.removeItem(index);
                            }}
                          />

                          <br />

                          <br />
                        </Segment>
                      ))}

                      <br />
                      <br />
                    </div>
                  </div>
                </Form>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button basic color="black" onClick={this.handleCloseDuplicate}>
                {" "}
                {i18n.t("Cancel.label")}
              </Button>
              <Button
                basic
                color={this.state.viewBoxSubmit ? "red" : "teal"}
                onClick={this.state.disableButtton ? null : this.duplicate}
              >
                {this.state.viewBoxSubmit == false ? (
                  <div>
                    {i18n.t("Submit.label")} <Icon name="right chevron" />
                  </div>
                ) : (
                  <div>
                    <Icon name="circle notched" loading />
                    Collecting Data...
                  </div>
                )}
              </Button>
            </Modal.Actions>
          </Modal>
          <br />
          <br />
          <SemanticToastContainer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(Profiled);
